import React from "react";
import { useLocation } from "react-router-dom";


const useLocationPathname = () => {
  const location = useLocation();
  const currentPage = location.pathname;
  return currentPage.includes("/setting/conditional/") ? "15px" : "24px";
};


const Heading = () => {

  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      className="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm3 4a1 1 0 0 1 1 1v4h6V7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0v-4H9v4a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Z"
        clipRule="evenodd"
      ></path>
    </svg>
  );

};

const FullName = () => {
  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4H5Zm-.02 20h14.04c-.547-2.961-3.482-5.222-7.02-5.222-3.538 0-6.473 2.26-7.02 5.222ZM12 13.11A3.556 3.556 0 1 0 12 6a3.556 3.556 0 0 0 0 7.111Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const Email = () => {
  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}

      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M1 7.52V18a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7.52l-9.28 6.496a3 3 0 0 1-3.44 0L1 7.521Zm21.881-2.358A3.001 3.001 0 0 0 20 3H4a3.001 3.001 0 0 0-2.881 2.162l10.308 7.216a1 1 0 0 0 1.146 0l10.308-7.216Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const Address = () => {
  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M12 1a9 9 0 0 0-9 9c0 2.324.971 4.384 2.34 6.274 1.35 1.867 3.159 3.66 4.96 5.446l.037.036c.318.316.637.632.956.951a1 1 0 0 0 1.414 0c.319-.319.638-.635.956-.95l.037-.037c1.801-1.786 3.61-3.58 4.96-5.446C20.03 14.384 21 12.324 21 10a9 9 0 0 0-9-9ZM8 9a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};


const Phone = () => {

  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="m10.17 8.38-.412.41c.095.228.221.51.377.82.41.819 1 1.792 1.753 2.544.752.753 1.726 1.344 2.544 1.753.311.156.592.282.82.377l.41-.411a2.21 2.21 0 0 1 3.125 0l2.607 2.607a2.21 2.21 0 0 1 0 3.124l-1.408 1.41c-1.008 1.006-2.557 1.299-3.862.631-2.077-1.062-5.956-3.2-8.24-5.486-2.286-2.285-4.424-6.163-5.487-8.241-.668-1.305-.375-2.854.632-3.861l1.409-1.41a2.21 2.21 0 0 1 3.124 0l2.607 2.608a2.209 2.209 0 0 1 0 3.124Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const DatePicker = () => {
  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      fill={size === "15px" ? "black" : "white"}
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M8 1a1 1 0 0 1 1 1v1h6V2a1 1 0 1 1 2 0v1h2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2V2a1 1 0 0 1 1-1Zm12 5v3H4V6a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0V5h2a1 1 0 0 1 1 1Zm-4.625 7.963c-.2-.391-.512-.587-.939-.587-.427 0-.743.196-.95.587-.198.39-.298 1.07-.298 2.037 0 .967.1 1.646.299 2.037.206.391.522.587.95.587.426 0 .739-.196.938-.587.206-.39.31-1.07.31-2.037 0-.967-.104-1.646-.31-2.037Zm1.387 5.098c-.505.626-1.28.939-2.326.939-1.045 0-1.824-.313-2.336-.939-.505-.625-.757-1.646-.757-3.061s.252-2.436.757-3.061c.512-.626 1.29-.939 2.336-.939 1.046 0 1.82.313 2.326.939.511.625.767 1.646.767 3.061s-.256 2.436-.767 3.061Zm-10.08-3.818-.15-.406a.875.875 0 0 1-.032-.522.886.886 0 0 1 .256-.448l1.43-1.344a1.512 1.512 0 0 1 1.045-.416h.683c.17 0 .312.06.426.181a.6.6 0 0 1 .17.427v6.57a.602.602 0 0 1-.17.427.562.562 0 0 1-.426.181H9.23a.602.602 0 0 1-.597-.608v-5.077h-.02l-1.28 1.184a.38.38 0 0 1-.363.107.39.39 0 0 1-.288-.256Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const Appointment = () => {
  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      fill={size === "15px" ? "black" : "white"}
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M8 1a1 1 0 0 1 1 1v1h6V2a1 1 0 1 1 2 0v1h2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2V2a1 1 0 0 1 1-1Zm12 5v3H4V6a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0V5h2a1 1 0 0 1 1 1Zm-4.043 8.207a1 1 0 0 0-1.414-1.414l-3.793 3.793-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

};

const Signature = () => {
  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      fill={size === "15px" ? "black" : "white"}
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M13.876 4.942 9.293 6.086A1.487 1.487 0 0 0 8.208 7.18l-2.334 9.64c-.07.292.287.492.5.28l5.108-5.109a1.86 1.86 0 1 1 .526.526l-5.109 5.109c-.212.212-.011.57.28.5l9.64-2.335c.538-.13.959-.548 1.093-1.085l1.144-4.583a1.487 1.487 0 0 0-.392-1.412l-3.376-3.377a1.487 1.487 0 0 0-1.412-.39Zm1.758-.463a1.11 1.11 0 0 1 0-1.571l.582-.583a1.11 1.11 0 0 1 1.57 0l3.889 3.888a1.11 1.11 0 0 1 0 1.571l-.583.582a1.11 1.11 0 0 1-1.57 0L15.633 4.48Z"
        clipRule="evenodd"
      ></path>
      <path
        fillRule="evenodd"
        d="M4.754 15.59a.6.6 0 0 1-.659 1.002l-.005-.001c-.003 0-.019-.005-.056.015a.285.285 0 0 0-.057.04c0 .007-.001.02.001.042.016.146.104.357.274.706l.043.087c.143.29.323.656.422 1.022.029.11.053.226.067.346.24.041.48.128.692.287.379.285.468.703.502.948v-.002l.031-.063c.092-.19.217-.449.376-.666.183-.25.474-.536.92-.605.535-.082.943.132 1.23.431.245.256.421.596.553.848l.011.023c.153.294.26.495.383.63.097.11.156.125.23.12.11-.006.26-.057.45-.183.184-.122.37-.29.54-.473a5.588 5.588 0 0 0 .556-.702l.006-.01a.6.6 0 0 1 1.014.642v.001l-.002.002-.003.005-.011.017a4.237 4.237 0 0 1-.18.259 6.76 6.76 0 0 1-.504.607 4.355 4.355 0 0 1-.754.653c-.286.19-.643.358-1.043.38-.534.031-.923-.216-1.192-.516-.232-.258-.404-.59-.534-.839l-.02-.039c-.152-.293-.256-.479-.367-.595-.076-.08-.111-.085-.18-.075-.004 0-.013.002-.032.016a.51.51 0 0 0-.102.111 3.33 3.33 0 0 0-.27.493l-.027.054-.006.013c-.093.191-.24.491-.456.693a.972.972 0 0 1-.541.264 1.03 1.03 0 0 1-.629-.133c-.52-.288-.588-.818-.617-1.048a1.508 1.508 0 0 0-.056-.303.494.494 0 0 0-.245-.071l-.108.191-.129.227c-.11.192-.243.412-.39.598-.127.162-.348.41-.663.5a.857.857 0 0 1-.585-.036 1.042 1.042 0 0 1-.42-.349 1.058 1.058 0 0 1-.21-.689c.012-.239.105-.445.215-.608.216-.316.559-.557.896-.72.15-.072.309-.135.474-.186a1.333 1.333 0 0 0-.03-.136c-.066-.247-.193-.508-.348-.824l-.035-.07c-.148-.303-.348-.712-.39-1.107a1.262 1.262 0 0 1 .117-.703 1.3 1.3 0 0 1 .55-.554 1.267 1.267 0 0 1 1.168-.045 1.102 1.102 0 0 1 .115.064l.012.008.004.003.003.002.001.001Zm-.776 1.048v.002Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

};

const FillInTheBlank = () => {
  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      fill={size === "15px" ? "black" : "white"}
      width={size}
      height={size}
    >
      <path
        fillRule="white"
        d="M9.966 7.3v.088c0 .402.083.712.248.93a.783.783 0 0 0 .656.329.768.768 0 0 0 .647-.337c.171-.23.257-.553.257-.966 0-.432-.08-.757-.24-.975a.777.777 0 0 0-.664-.328.776.776 0 0 0-.656.336c-.165.22-.248.526-.248.922Zm-.913 2.349a.485.485 0 0 1-.355-.151.485.485 0 0 1-.15-.355V3.505c0-.136.05-.254.15-.354.1-.1.219-.151.355-.151h.407c.136 0 .255.05.355.15.1.101.15.22.15.355V5.59c0 .005.004.008.01.008.011 0 .017-.003.017-.008.349-.426.783-.639 1.303-.639.562 0 1.008.207 1.339.62.331.414.496 1.005.496 1.774 0 .75-.17 1.338-.514 1.764a1.63 1.63 0 0 1-1.32.63c-.556 0-1.014-.237-1.375-.71 0-.012-.006-.018-.017-.018-.006 0-.01.003-.01.01l-.008.123a.511.511 0 0 1-.523.505h-.31Zm-4.238-5.16-.691 2.544c0 .018.006.036.018.054a.06.06 0 0 0 .044.017h1.276a.06.06 0 0 0 .045-.017c.017-.018.023-.036.017-.054L4.833 4.49c0-.006-.003-.009-.009-.009-.006 0-.009.003-.009.01ZM2.36 9.65a.339.339 0 0 1-.293-.151.343.343 0 0 1-.044-.328l1.861-5.514a.753.753 0 0 1 .258-.346.686.686 0 0 1 .407-.133h.585c.154 0 .29.045.408.133a.68.68 0 0 1 .257.346L7.67 9.17a.33.33 0 0 1-.052.328.34.34 0 0 1-.293.15H6.73a.674.674 0 0 1-.399-.132.694.694 0 0 1-.24-.355l-.22-.842c-.007-.047-.04-.071-.098-.071H3.876c-.054 0-.086.024-.098.07l-.222.843a.629.629 0 0 1-.239.355.648.648 0 0 1-.399.133H2.36ZM16 6a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5ZM3 16a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H3Zm13.78 2.808c.1.1.218.15.354.15h.408c.136 0 .254-.05.354-.15.1-.1.15-.219.15-.355V16.54c0-.308.087-.58.258-.816.177-.242.381-.364.612-.364.254 0 .431.083.532.249.1.16.15.479.15.957v1.888c0 .136.05.255.151.355.1.1.219.15.355.15h.399c.135 0 .25-.05.345-.15.1-.1.15-.219.15-.355v-2.038c0-.787-.126-1.342-.38-1.667-.254-.325-.66-.488-1.215-.488-.526 0-.969.213-1.33.639 0 .006-.005.008-.017.008-.006 0-.01-.002-.01-.008v-2.084a.485.485 0 0 0-.15-.354.485.485 0 0 0-.354-.15h-.408a.485.485 0 0 0-.355.15c-.1.1-.15.218-.15.354v5.638c0 .136.05.255.15.355Zm-4.362-3.165a.784.784 0 0 1 .665-.319.8.8 0 0 1 .665.32c.165.206.248.499.248.877v.088c0 .385-.083.68-.248.887a.808.808 0 0 1-.665.31.775.775 0 0 1-.648-.328c-.165-.218-.248-.523-.248-.913 0-.408.077-.715.23-.922Zm-1.064 2.607c.349.413.783.62 1.303.62.562 0 1.01-.213 1.348-.638 0-.006.005-.01.017-.01h.01v.25c0 .549-.098.933-.293 1.151-.195.225-.518.337-.967.337-.277 0-.534-.032-.77-.097a.507.507 0 0 0-.373.035.429.429 0 0 0-.222.293l-.018.053a.552.552 0 0 0 .063.399c.07.124.174.204.31.24.325.076.682.115 1.072.115 1.72 0 2.58-.849 2.58-2.545v-3.599a.485.485 0 0 0-.15-.354.457.457 0 0 0-.346-.151h-.31a.525.525 0 0 0-.373.15.497.497 0 0 0-.16.355v.124c0 .006-.002.01-.008.01l-.018-.018c-.372-.473-.836-.71-1.392-.71-.555 0-.999.201-1.33.603-.325.402-.487.97-.487 1.702 0 .71.171 1.27.514 1.684Z"
        clipRule="white"
      ></path>
    </svg>
  )

};

const ProductList = () => {


  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      fill={size === "15px" ? "black" : "white"}
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M2 3h1l.19 2.072.764 12.24.001.022c.007.113.016.248.033.367.02.139.06.335.175.538a1.5 1.5 0 0 0 .65.61c.209.102.407.13.547.142.12.01.255.01.368.009h13.265a1 1 0 0 0 0-2H5.938l-.125-2h12.353c.475 0 .888 0 1.23-.027.364-.028.725-.09 1.08-.256a3 3 0 0 0 1.286-1.152c.204-.334.306-.686.374-1.044.064-.338.11-.749.162-1.221l.003-.026.682-5.142.003-.022a2.467 2.467 0 0 0-.168-1.186 1.5 1.5 0 0 0-.66-.737 1.511 1.511 0 0 0-.613-.176C21.41 4 21.256 4 21.125 4h-16l-.082-1.312v-.022c-.008-.112-.016-.248-.033-.367a1.49 1.49 0 0 0-.176-.538 1.5 1.5 0 0 0-.65-.61 1.505 1.505 0 0 0-.547-.142C3.517 1 3.382 1 3.27 1H2a1 1 0 0 0 0 2Zm5.498 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm8.996 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

};

const ShortText = () => {

  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      fill={size === "15px" ? "black" : "white"}
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M14 2a1 1 0 1 0 0 2 2 2 0 0 1 2 2v12a2 2 0 0 1-2 2 1 1 0 1 0 0 2 4 4 0 0 0 3-1.354A3.998 3.998 0 0 0 20 22a1 1 0 1 0 0-2 2 2 0 0 1-2-2V6a2 2 0 0 1 2-2 1 1 0 1 0 0-2 4 4 0 0 0-3 1.354 3.979 3.979 0 0 0-1.47-1.05A4 4 0 0 0 14 2Zm1 4H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12v-2H3V8h12V6Zm4 12v-2h2V8h-2V6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2ZM7.61 10.216l-.64 2.36c0 .016.005.032.016.049.01.01.024.016.04.016H8.21c.017 0 .03-.005.041-.016.017-.017.022-.033.017-.05l-.641-2.359c0-.005-.003-.008-.009-.008-.005 0-.008.003-.008.008ZM5.334 15a.314.314 0 0 1-.272-.14.318.318 0 0 1-.04-.304l1.725-5.112a.698.698 0 0 1 .239-.32A.637.637 0 0 1 7.364 9h.542c.143 0 .269.041.378.123a.63.63 0 0 1 .239.32l1.734 5.113a.305.305 0 0 1-.05.304.314.314 0 0 1-.27.14h-.551a.624.624 0 0 1-.37-.123.643.643 0 0 1-.222-.33l-.206-.78c-.005-.044-.035-.066-.09-.066H6.739c-.05 0-.08.022-.09.066l-.206.78a.583.583 0 0 1-.222.33.601.601 0 0 1-.37.123h-.517Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

};

const ShortTextBlue = () => {


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#0293e2"
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={"15px"}
      height={"15px"}
    >
      <path
        fillRule="evenodd"
        d="M14 2a1 1 0 1 0 0 2 2 2 0 0 1 2 2v12a2 2 0 0 1-2 2 1 1 0 1 0 0 2 4 4 0 0 0 3-1.354A3.998 3.998 0 0 0 20 22a1 1 0 1 0 0-2 2 2 0 0 1-2-2V6a2 2 0 0 1 2-2 1 1 0 1 0 0-2 4 4 0 0 0-3 1.354 3.979 3.979 0 0 0-1.47-1.05A4 4 0 0 0 14 2Zm1 4H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12v-2H3V8h12V6Zm4 12v-2h2V8h-2V6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2ZM7.61 10.216l-.64 2.36c0 .016.005.032.016.049.01.01.024.016.04.016H8.21c.017 0 .03-.005.041-.016.017-.017.022-.033.017-.05l-.641-2.359c0-.005-.003-.008-.009-.008-.005 0-.008.003-.008.008ZM5.334 15a.314.314 0 0 1-.272-.14.318.318 0 0 1-.04-.304l1.725-5.112a.698.698 0 0 1 .239-.32A.637.637 0 0 1 7.364 9h.542c.143 0 .269.041.378.123a.63.63 0 0 1 .239.32l1.734 5.113a.305.305 0 0 1-.05.304.314.314 0 0 1-.27.14h-.551a.624.624 0 0 1-.37-.123.643.643 0 0 1-.222-.33l-.206-.78c-.005-.044-.035-.066-.09-.066H6.739c-.05 0-.08.022-.09.066l-.206.78a.583.583 0 0 1-.222.33.601.601 0 0 1-.37.123h-.517Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )



};

const LongText = () => {


  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M1 4a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4Zm3-1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Zm7.285 7.44v1.408c0 .048.024.077.072.088.112.021.248.032.408.032.378 0 .656-.07.832-.208.176-.144.264-.363.264-.656 0-.49-.4-.736-1.2-.736h-.312c-.043 0-.064.024-.064.072Zm0-2.288v1.176c0 .043.021.064.064.064h.2c.778 0 1.168-.232 1.168-.696 0-.443-.326-.664-.976-.664-.155 0-.286.01-.392.032-.043.01-.064.04-.064.088Zm-.888 4.784a.454.454 0 0 1-.32-.168.52.52 0 0 1-.128-.344V7.576a.5.5 0 0 1 .128-.344c.09-.101.2-.157.328-.168A11.9 11.9 0 0 1 11.629 7c1.546 0 2.32.499 2.32 1.496 0 .336-.11.621-.328.856-.214.235-.502.384-.864.448-.006 0-.008.005-.008.016 0 .005.005.008.016.008.421.059.754.219 1 .48.25.261.376.573.376.936 0 .592-.198 1.035-.592 1.328-.39.288-1.003.432-1.84.432-.422 0-.859-.021-1.312-.064ZM6.54 8.264l-.624 2.296c0 .016.005.032.016.048.01.01.024.016.04.016h1.152a.054.054 0 0 0 .04-.016c.016-.016.021-.032.016-.048l-.624-2.296c0-.005-.003-.008-.008-.008-.006 0-.008.003-.008.008ZM4.325 12.92a.306.306 0 0 1-.264-.136.31.31 0 0 1-.04-.296L5.7 7.512a.68.68 0 0 1 .232-.312.62.62 0 0 1 .368-.12h.528c.138 0 .261.04.368.12.112.08.189.184.232.312l1.688 4.976a.298.298 0 0 1-.048.296.306.306 0 0 1-.264.136h-.536a.608.608 0 0 1-.36-.12.626.626 0 0 1-.216-.32l-.2-.76c-.006-.043-.035-.064-.088-.064H5.693c-.048 0-.078.021-.088.064l-.2.76a.568.568 0 0 1-.216.32.585.585 0 0 1-.36.12h-.504ZM14 4.5a.5.5 0 0 0 0 1A1.5 1.5 0 0 1 15.5 7v6a1.5 1.5 0 0 1-1.5 1.5.5.5 0 0 0 0 1 2.5 2.5 0 0 0 2-1 2.51 2.51 0 0 0 1.043.81 2.5 2.5 0 0 0 .957.19.5.5 0 0 0 0-1 1.5 1.5 0 0 1-1.5-1.5V7A1.502 1.502 0 0 1 18 5.5a.5.5 0 0 0 0-1 2.5 2.5 0 0 0-2 1 2.502 2.502 0 0 0-2-1Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const Paragraph = () => {


  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path d="m7.31 8.475-1.304 4.799a.18.18 0 0 0 .033.1c.023.022.05.033.084.033h2.408a.113.113 0 0 0 .083-.033c.034-.034.045-.067.034-.1l-1.304-4.8c0-.01-.006-.016-.017-.016-.011 0-.017.006-.017.017Zm-4.63 9.731a.64.64 0 0 1-.552-.284.646.646 0 0 1-.084-.619l3.512-10.4c.1-.268.261-.485.484-.652.235-.167.49-.251.77-.251h1.103c.29 0 .546.084.77.25.233.168.395.385.484.653l3.528 10.4a.623.623 0 0 1-.1.619.64.64 0 0 1-.552.284h-1.12a1.27 1.27 0 0 1-.753-.25 1.308 1.308 0 0 1-.451-.67L9.3 15.699c-.011-.09-.072-.134-.184-.134H5.538c-.1 0-.162.045-.184.134l-.418 1.589c-.067.267-.218.49-.452.668a1.216 1.216 0 0 1-.752.251H2.679Zm15.933-3.996c-.758 0-1.337.117-1.738.351-.39.234-.586.546-.586.937 0 .3.09.534.268.702.19.167.44.25.752.25.558 0 1.015-.172 1.371-.518.368-.345.552-.786.552-1.32v-.268c0-.09-.05-.134-.15-.134h-.469Zm-2.006 4.163c-.836 0-1.505-.234-2.006-.702-.502-.468-.753-1.109-.753-1.923 0-.958.407-1.727 1.22-2.307.826-.58 2.007-.87 3.545-.87h.469c.1 0 .15-.05.15-.15-.01-.446-.117-.753-.317-.92-.19-.178-.524-.267-1.004-.267-.769 0-1.566.133-2.39.4a.822.822 0 0 1-.67-.05.717.717 0 0 1-.368-.518l-.016-.033a1.13 1.13 0 0 1 .117-.786.97.97 0 0 1 .602-.485 9.804 9.804 0 0 1 2.842-.418c1.394 0 2.386.268 2.977.803.602.524.902 1.388.902 2.591v3.127c0 .546.028 1.015.084 1.405a.811.811 0 0 1-.184.652.744.744 0 0 1-.602.284h-.635a1.11 1.11 0 0 1-.736-.267 1.04 1.04 0 0 1-.351-.67 1.159 1.159 0 0 1-.033-.133v-.134c0-.01-.006-.016-.017-.016-.022 0-.034.005-.034.016a3.132 3.132 0 0 1-1.204 1.004 3.571 3.571 0 0 1-1.588.367Z"></path>
    </svg>
  )


};

const DropDown = () => {

  const size = useLocationPathname();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="white"
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm8.293 4.293a1 1 0 0 1 1.414 0L16 7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414ZM2 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h15a1 1 0 1 0 0-2H3Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const DropDownFill = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#0293e2"
    viewBox="0 0 24 24"
    classNameName="field-iconSvg"
    width={"15px"}
    height={"15px"}
  >
    <path
      fillRule="evenodd"
      d="M5 2a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm8.293 4.293a1 1 0 0 1 1.414 0L16 7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414ZM2 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h15a1 1 0 1 0 0-2H3Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const SingleChoice = () => {


  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

};

const MultiChoice = () => {

  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm12.707 7.707a1 1 0 0 0-1.414-1.414L11 13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l6-6Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const Number = () => {


  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm2.732 6.137c.202.202.44.303.713.303h5.218c.023 0 .035.012.035.035 0 .024-.012.048-.035.072-1.829 2.896-3.402 6.06-4.72 9.491a.655.655 0 0 0 .072.66.68.68 0 0 0 .587.302h1.211c.297 0 .57-.089.82-.267.249-.178.42-.41.516-.695 1.092-3.205 2.398-6.12 3.918-8.743a3.773 3.773 0 0 0 .498-1.87v-.41c0-.273-.1-.51-.302-.712A.918.918 0 0 0 15.568 6H8.445c-.273 0-.51.1-.713.303a.975.975 0 0 0-.302.712v.41c0 .273.1.51.302.712Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const Image = () => {

  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V6Zm9 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm5.248 2.312 5.59 7.416A.794.794 0 0 1 20.204 19H3.796a.794.794 0 0 1-.643-1.26l3.63-5.002a.794.794 0 0 1 1.285 0l2.003 2.76 3.909-5.186a.794.794 0 0 1 1.268 0Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const FileUpload = () => {

  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M1 6V5a3 3 0 0 1 3-3h5.724a3 3 0 0 1 2.72 1.733L13.5 6H20a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V6Zm10 11a1 1 0 1 0 2 0v-2h2a1 1 0 0 0 .707-1.707l-3-3a1 1 0 0 0-1.414 0l-3 3A1 1 0 0 0 9 15h2v2Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

};

const Time = () => {

  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm0 5a1 1 0 0 1 1 1v5h3a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

};

const Captcha = () => {

  const size = useLocationPathname();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M4 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H4Zm9.12 4.296.05 1.525.092.049c.135.07.29.11.46.126.11.01.208.015.272.005l.098-.016.039-.092c.25-.599.407-1.254.47-1.962l.011-.117-.102-.056a5.633 5.633 0 0 0-2.235-.674 4.335 4.335 0 0 0-1.552.131 3.465 3.465 0 0 0-1.314.683 3.76 3.76 0 0 0-.948 1.178l-.002.003c-.244.48-.392 1.03-.447 1.647v.003a4.744 4.744 0 0 0 .15 1.667v.003c.155.501.38.942.678 1.321.299.379.66.684 1.082.913l.003.002c.423.218.874.35 1.353.392.99.089 1.889-.211 2.688-.889l.078-.065-.017-.1c-.037-.217-.13-.4-.301-.513l-.088-.058-.093.05c-.712.372-1.352.524-1.925.473-.6-.054-1.053-.328-1.376-.828-.313-.5-.441-1.226-.354-2.203a5.38 5.38 0 0 1 .25-1.255c.125-.363.287-.662.485-.9l.002-.003c.199-.247.428-.426.687-.54.268-.113.571-.157.916-.126.355.032.65.109.89.226Zm-8.217-1.53c-.263-.184-.546-.248-.835-.161-.278.083-.501.273-.674.546-.166.263-.248.528-.174.774.078.26.26.474.52.648l.003.002c.265.169.54.23.812.149.283-.085.509-.267.677-.532.168-.266.247-.536.17-.788-.076-.258-.25-.469-.5-.637Zm1.21 2.706 1.838 6.119.978-.002.048.101c.095.196.127.4.09.607l-.02.116-.113.027c-.836.201-1.348.33-1.542.389-.268.08-.813.268-1.638.566l-.152.055-.07-.145a1.266 1.266 0 0 1-.134-.567l.001-.102.09-.05c.235-.135.424-.248.566-.34.081-.052.144-.095.191-.13l-1.52-5.061-1.145.227-.06-.126a.966.966 0 0 1-.088-.61l.017-.089.082-.038a18.14 18.14 0 0 0 1.785-.934l.025-.015.027-.007c.187-.044.4-.044.633-.008l.112.017ZM19.1 16.24h.001c.706-.331 1.15-.872 1.32-1.615a1.88 1.88 0 0 0-.227-1.427c-.217-.384-.534-.764-.948-1.14.94-.38 1.522-.942 1.689-1.704a1.96 1.96 0 0 0-.314-1.626c-.345-.493-.882-.816-1.59-.978-.748-.171-1.414-.103-1.986.22l-.001.002c-.56.323-.915.795-1.056 1.41-.18.787.067 1.54.703 2.249-.52.115-.948.293-1.28.537-.387.287-.64.712-.764 1.257-.165.722-.035 1.37.395 1.931l.002.002c.435.549 1.048.91 1.826 1.087.788.18 1.534.114 2.23-.205Zm-.125-2.198.003.006c.075.205.09.408.043.61-.104.455-.324.758-.65.934-.335.18-.723.225-1.174.122-.453-.104-.789-.335-1.019-.691-.225-.35-.286-.791-.16-1.343.159-.627.607-1.09 1.384-1.38.264.215.48.397.646.546l.003.003c.177.15.36.335.55.553.182.212.305.425.374.64Zm.503-5.023.002.004c.183.263.235.626.124 1.113-.124.543-.472.969-1.067 1.276a5.347 5.347 0 0 1-.971-.944c-.24-.318-.32-.68-.231-1.097.086-.374.252-.623.485-.77h.003c.237-.155.526-.2.882-.119.335.077.59.254.773.537Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const Spinner = () => {

  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M5.079 4.693c.222-.25.532-.375.932-.375.393 0 .7.125.922.375.229.243.343.59.343 1.04 0 .443-.114.79-.343 1.04-.221.25-.529.374-.922.374s-.703-.121-.932-.364c-.221-.25-.332-.6-.332-1.05 0-.45.11-.797.332-1.04ZM3.664 7.715c.443.443 1.08.665 1.908.665a2.83 2.83 0 0 0 1.5-.418h.011l.01.021c-.2.458-.489.811-.867 1.061-.372.25-.861.411-1.468.482a.534.534 0 0 0-.461.643l.064.28c.036.17.121.31.257.417.143.107.3.15.472.129 1.229-.143 2.193-.643 2.893-1.5.7-.865 1.05-2.005 1.05-3.42 0-.978-.267-1.735-.803-2.271C7.694 3.268 6.954 3 6.01 3c-.9 0-1.629.254-2.186.76C3.275 4.262 3 4.919 3 5.734c0 .871.221 1.532.664 1.982Zm12.629-2.422a1 1 0 0 1 1.414 0l3 3A1 1 0 0 1 20 10h-2v8a1 1 0 1 1-2 0v-8h-2a1 1 0 0 1-.707-1.707l3-3ZM5.57 14.2l-1.286 1.21a.898.898 0 0 0-.26.452.887.887 0 0 0 .033.528l.134.364a.45.45 0 0 0 .329.292l.004.001a.44.44 0 0 0 .415-.121l1-.926v4.353c0 .173.062.326.181.452l.002.003c.127.126.28.192.455.192h.613c.18 0 .335-.065.457-.195a.636.636 0 0 0 .18-.452v-5.906a.641.641 0 0 0-.18-.452.605.605 0 0 0-.457-.195h-.613a1.46 1.46 0 0 0-1.007.4Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

};

const Submit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
    viewBox="0 0 24 24"
    classNameName="field-iconSvg"
    width={"24px"}
    height={"24px"}
  >
    <path
      fillRule="evenodd"
      d="M4 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H4Zm17 7.933c0-.793-.235-1.41-.705-1.852-.466-.448-1.122-.671-1.97-.671-.346 0-.698.018-1.058.055a.416.416 0 0 0-.283.145.432.432 0 0 0-.11.298v4.189c0 .115.036.216.11.304a.427.427 0 0 0 .283.138c.36.037.712.055 1.058.055.848 0 1.505-.23 1.97-.69.47-.466.705-1.123.705-1.971ZM4.77 12.5c-.632-.184-1.086-.408-1.362-.67A1.331 1.331 0 0 1 3 10.84c0-.437.164-.785.49-1.043.328-.258.789-.387 1.383-.387.461 0 .89.064 1.286.194a.376.376 0 0 1 .235.2c.05.101.062.207.035.318l-.035.152a.311.311 0 0 1-.173.214.322.322 0 0 1-.276.014 2.943 2.943 0 0 0-1.023-.173c-.24 0-.422.046-.546.139a.44.44 0 0 0-.187.373c0 .258.193.442.58.553.687.189 1.169.415 1.445.677.281.263.422.602.422 1.016 0 .489-.166.862-.498 1.12-.332.258-.822.387-1.472.387-.452 0-.899-.099-1.341-.297a.426.426 0 0 1-.228-.228.483.483 0 0 1-.007-.332l.048-.173a.29.29 0 0 1 .18-.193.308.308 0 0 1 .27.014c.387.193.762.29 1.126.29.24 0 .42-.048.54-.145a.514.514 0 0 0 .186-.422.463.463 0 0 0-.152-.36c-.097-.091-.27-.174-.518-.248Zm3.13 2.025a.39.39 0 0 1-.387-.394V9.873a.39.39 0 0 1 .388-.394h2.447a.36.36 0 0 1 .27.118c.078.078.117.17.117.276v.16c0 .105-.04.197-.117.276a.356.356 0 0 1-.27.117H8.744c-.037 0-.055.018-.055.055v.913c0 .041.018.062.055.062h1.466a.36.36 0 0 1 .27.118c.078.078.117.17.117.276v.104c0 .106-.04.198-.118.276a.356.356 0 0 1-.27.118H8.745c-.037 0-.055.018-.055.055v1.12c0 .037.018.055.055.055h1.604a.36.36 0 0 1 .27.118c.078.078.117.17.117.276v.16c0 .105-.04.197-.117.276a.356.356 0 0 1-.27.117H7.9Zm3.934-.117c.078.078.17.117.277.117h.366a.358.358 0 0 0 .27-.117.378.378 0 0 0 .117-.277v-2.696c0-.004.002-.007.007-.007.01 0 .014.003.014.007l1.59 2.752c.133.225.33.338.587.338h.367a.377.377 0 0 0 .276-.117.379.379 0 0 0 .118-.277V9.873a.379.379 0 0 0-.118-.276.378.378 0 0 0-.276-.118h-.367a.39.39 0 0 0-.387.394v2.696c0 .005-.002.007-.007.007-.009 0-.014-.002-.014-.007l-1.59-2.751a.643.643 0 0 0-.587-.339h-.366a.378.378 0 0 0-.277.118.379.379 0 0 0-.117.276v4.258c0 .106.039.198.117.277Zm6.194-3.975v3.138c0 .042.018.067.055.076.092.019.203.028.332.028.977 0 1.465-.58 1.465-1.742 0-1.07-.488-1.604-1.465-1.604-.13 0-.24.01-.332.028-.037.01-.055.035-.055.076Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const Table = () => {

  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm14 15h3a1 1 0 0 0 1-1v-3h-4v4Zm-2-4v4h-4v-4h4Zm2-2h4v-4h-4v4Zm-2-4v4h-4v-4h4Zm1-2h5V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3h11ZM8 20v-4H4v3a1 1 0 0 0 1 1h3Zm0-6v-4H4v4h4Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const StarRating = () => {

  const size = useLocationPathname();


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M12 2.5c.371 0 .709.215.864.55l2.461 5.304 5.836.687a.95.95 0 0 1 .792.647.942.942 0 0 1-.258.987l-4.315 3.966 1.146 5.729a.943.943 0 0 1-.375.95c-.3.216-.7.24-1.023.06L12 18.526 6.872 21.38a.956.956 0 0 1-1.024-.06.943.943 0 0 1-.373-.95l1.145-5.73-4.315-3.965a.942.942 0 0 1-.258-.987.95.95 0 0 1 .792-.647l5.836-.687 2.461-5.304A.952.952 0 0 1 12 2.5Zm0 7a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

};

const ScaleRating = () => {

  const size = useLocationPathname();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={size === "15px" ? "black" : "white"}
      viewBox="0 0 24 24"
      classNameName="field-iconSvg"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        d="M9.5 4a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2V4ZM2 14a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6Zm17-6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-1Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )


};

const Divider = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
    viewBox="0 0 24 24"
    classNameName="field-iconSvg"
    width={"24px"}
    height={"24px"}
  >
    <path
      fillRule="evenodd"
      d="M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const Section = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
    viewBox="0 0 24 24"
    classNameName="field-iconSvg"
    width={"24px"}
    height={"24px"}
  >
    <path
      fillRule="evenodd"
      d="M2 3a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm9.375 3.22a1 1 0 0 1 1.25 0l2.5 2a1 1 0 1 1-1.25 1.56L13 9.08v5.84l.875-.7a1 1 0 0 1 1.25 1.56l-2.5 2a1 1 0 0 1-1.25 0l-2.5-2a1 1 0 0 1 1.25-1.56l.875.7V9.08l-.875.7a1 1 0 1 1-1.25-1.56l2.5-2ZM3 20a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const Page = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
    viewBox="0 0 24 24"
    classNameName="field-iconSvg"
    width={"24px"}
    height={"24px"}
  >
    <path
      fillRule="evenodd"
      d="M2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm19 8a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1Zm-6 0a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1Zm-8 0a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1Zm-3 3a2 2 0 0 0-2 2v3a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3a2 2 0 0 0-2-2H4Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const List = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 6L21 6.00078M8 12L21 12.0008M8 18L21 18.0007M3 6.5H4V5.5H3V6.5ZM3 12.5H4V11.5H3V12.5ZM3 18.5H4V17.5H3V18.5Z"
      stroke="#FFFFFF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const TableParagraph = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="white"
    stroke-width="1"
    stroke-linecap="round"
    stroke-linejoin="miter"
  >
    <rect x="3" y="3" width="18" height="18" rx="0"></rect>
    <line x1="9" y1="3" x2="9" y2="21"></line>
    <line x1="15" y1="3" x2="15" y2="21"></line>
    <line x1="21" y1="9" x2="3" y2="9"></line>
    <line x1="21" y1="15" x2="3" y2="15"></line>
  </svg>
);

const ABCList = () => (
  <svg
    fill="white"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width={"20px"}
    height={"20px"}
    viewBox="0 0 511.998 511.998"
  >
    <g>
      <g>
        <rect x="161.605" y="359.567" width="350.393" height="70.078" />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M59.599,45.267H33.625L0,149.322h24.326l5.865-21.236h32.841l5.94,21.236h24.326L59.599,45.267z M35.557,111.098
			l10.805-38.225h0.427l10.875,38.225H35.557z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M88.928,263.393c-2.905-4.179-7.414-6.948-13.519-8.331c4.865-1.956,8.465-4.865,10.805-8.73
			c2.336-3.861,3.504-8.273,3.504-13.234c0-9.492-3.625-16.604-10.875-21.399c-7.25-4.793-17.337-7.161-30.265-7.161H12.956v104.056
			h40.773c12.737,0,22.514-2.57,29.335-7.768c6.819-5.199,10.232-12.865,10.232-23.026
			C93.296,272.361,91.839,267.566,88.928,263.393z M36.313,223.648h0.002h12.262c5.723,0,9.97,0.731,12.737,2.756
			c2.767,2.028,4.147,5.116,4.147,9.554c0,3.912-1.357,6.358-4.077,8.384c-2.716,2.028-6.823,2.665-12.306,2.665H36.313V223.648z
			 M65.322,286.723c-2.576,2.028-6.441,2.756-11.593,2.756H36.316v-25.483H55.09c4.961,0,8.547,1.123,10.767,3.438
			c2.219,2.315,3.326,5.579,3.326,10.11C69.182,281.741,67.898,284.695,65.322,286.723z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M37.573,384.776c3.147-4.411,7.851-6.617,13.338-6.617c6.488,0,11.274,1.44,13.971,4.731
			c2.693,3.292,4.4,8.522,4.736,14.893h23.538l0.144-0.225c-0.909-12.209-4.844-21.529-11.805-28.157
			c-6.97-6.632-17.033-9.843-30.197-9.843c-12.402,0-22.844,3.969-30.597,11.911c-7.751,7.94-11.994,18.208-11.994,30.801v21.75
			c0,12.64,4.396,22.92,12.459,30.837c8.059,7.919,18.717,11.875,31.595,11.875c12.829,0,22.708-3.219,29.461-9.658
			c6.749-6.439,10.408-15.279,10.883-27.49l-0.096,0.051H69.473c-0.336,6.371-1.718,11.227-4.152,14.328
			c-2.432,3.1-6.558,4.406-12.376,4.406c-6.01,0-11.512-2.338-14.946-6.772c-3.434-4.436-5.929-10.376-5.929-17.577v-21.894
			C32.07,394.971,34.426,389.186,37.573,384.776z"
        />
      </g>
    </g>
    <g>
      <g>
        <rect x="161.605" y="221.533" width="350.393" height="70.078" />
      </g>
    </g>
    <g>
      <g>
        <rect x="161.605" y="79.252" width="350.393" height="70.078" />
      </g>
    </g>
  </svg>
);

const UploadFileIcon = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 -4 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>cloud-upload</title>
    <desc>Created with Sketch Beta.</desc>
    <defs></defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="#fbfcff"
      fillRule="evenodd"
    >
      <g
        id="Icon-Set"
        transform="translate(-464.000000, -1139.000000)"
        fill="#000000"
      >
        <path
          d="M489,1161 L472,1161 C472,1161 465.962,1160.38 466,1155 C466.021,1151.96 468.688,1149.18 472,1149 C472,1144.86 474.65,1141 479,1141 C482.433,1141 484.723,1143.1 485.538,1146.01 C490.493,1145.8 493.844,1149.72 494,1153 C494.135,1155.83 491.68,1159.48 489,1161 L489,1161 Z M487.067,1144.03 C485.599,1141.05 482.543,1139 479,1139 C474.251,1139 470.37,1142.68 470.033,1147.34 C466.542,1148.34 464,1151.39 464,1155 C464,1159.26 467.54,1162.73 472,1162.98 L489,1163 C492.437,1161.51 496,1157.35 496,1153.5 C496,1148.44 492.049,1144.32 487.067,1144.03 L487.067,1144.03 Z M480.777,1145.28 C480.568,1145.07 480.29,1144.98 480.016,1145 C479.741,1144.98 479.464,1145.07 479.254,1145.28 L473.313,1151.19 C472.921,1151.59 472.921,1152.22 473.313,1152.61 C473.707,1153 474.344,1153 474.736,1152.61 L479,1148.37 L479,1157.99 C479,1158.54 479.447,1158.99 480,1158.99 C480.553,1158.99 481,1158.54 481,1157.99 L481,1148.34 L485.295,1152.61 C485.688,1153 486.325,1153 486.718,1152.61 C487.11,1152.22 487.11,1151.59 486.718,1151.19 L480.777,1145.28 L480.777,1145.28 Z"
          id="cloud-upload"
        ></path>
      </g>
    </g>
  </svg>
);

const SettingIcon = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none">
    <path
      d="M20.781 8.125 22.5 4.844l-2.188-2.188-3.28 1.719c-.47-.313-1.095-.469-1.72-.625L14.063 0h-3.124l-1.25 3.594c-.47.156-1.094.312-1.563.625L4.844 2.5 2.5 4.844l1.719 3.281c-.313.469-.469 1.094-.625 1.563L0 10.938v3.124l3.594 1.25c.156.626.469 1.094.625 1.72L2.5 20.311 4.688 22.5l3.28-1.719c.47.313 1.095.469 1.72.625L10.938 25h3.124l1.25-3.594c.626-.156 1.094-.468 1.72-.625l3.28 1.719 2.188-2.188-1.719-3.28c.313-.47.469-1.095.625-1.72L25 14.063v-3.124l-3.594-1.25c-.156-.47-.312-1.094-.625-1.563ZM12.5 17.188c-2.656 0-4.688-2.032-4.688-4.688 0-2.656 2.032-4.688 4.688-4.688 2.656 0 4.688 2.032 4.688 4.688 0 2.656-2.032 4.688-4.688 4.688Z"
      fill={fill}
    />
  </svg>
);

const EmailSetting = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.424.377c.045.035.08.058.109.085l9.466 8.818c.103.096.21.191.327.27.918.623 2.127.52 2.946-.242L23.75.475c.036-.034.068-.073.103-.11C23.39.093 22.896 0 22.376 0 15.892.001 9.406.002 2.922 0c-.52 0-1.013.094-1.498.377ZM.42 1.334c-.28.455-.416.92-.416 1.42-.002 4.14-.01 8.28.003 12.42.005 1.637 1.214 2.82 2.87 2.822 6.514.007 13.027.002 19.54.004.524 0 1.016-.11 1.462-.376.947-.564 1.412-1.403 1.416-2.49.004-1.167.001-2.335.001-3.502V2.916c0-.558-.103-1.087-.418-1.576-.052.044-.093.078-.132.115C21.93 4.076 19.117 6.699 16.3 9.32c-.475.441-.925.92-1.448 1.3-1.484 1.079-3.421.953-4.77-.295-2.936-2.72-5.86-5.453-8.789-8.18-.286-.267-.573-.532-.874-.811Z"
      fill={fill}
    />
  </svg>
);

const EmailSettingPage = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.424.377c.045.035.08.058.109.085l9.466 8.818c.103.096.21.191.327.27.918.623 2.127.52 2.946-.242L23.75.475c.036-.034.068-.073.103-.11C23.39.093 22.896 0 22.376 0 15.892.001 9.406.002 2.922 0c-.52 0-1.013.094-1.498.377ZM.42 1.334c-.28.455-.416.92-.416 1.42-.002 4.14-.01 8.28.003 12.42.005 1.637 1.214 2.82 2.87 2.822 6.514.007 13.027.002 19.54.004.524 0 1.016-.11 1.462-.376.947-.564 1.412-1.403 1.416-2.49.004-1.167.001-2.335.001-3.502V2.916c0-.558-.103-1.087-.418-1.576-.052.044-.093.078-.132.115C21.93 4.076 19.117 6.699 16.3 9.32c-.475.441-.925.92-1.448 1.3-1.484 1.079-3.421.953-4.77-.295-2.936-2.72-5.86-5.453-8.789-8.18-.286-.267-.573-.532-.874-.811Z"
      fill={fill}
    />
  </svg>
);

const Conditions = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fillRule="evenodd"
      d="M16 5a4.001 4.001 0 0 1-2.5 3.71v2.79h4A1.5 1.5 0 0 1 19 13v4h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2v-2.5H8V17h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2v-4a1.5 1.5 0 0 1 1.5-1.5h4V8.71A4.001 4.001 0 0 1 12 1a4 4 0 0 1 4 4Z"
      fill={fill}
      clipRule="evenodd"
    />
  </svg>
);

const Thanks = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none">
    <path
      d="M14 0C6.267 0 0 6.267 0 14s6.267 14 14 14 14-6.267 14-14S21.733 0 14 0Zm6.969 10.88-6.977 8.684c-.305.38-.745.615-1.21.655-.048.003-.095.003-.14.003-.425 0-.83-.158-1.157-.454l-4.256-3.881c-.74-.678-.826-1.864-.192-2.652.64-.786 1.757-.88 2.5-.203l2.91 2.656 5.82-7.244c.635-.794 1.755-.89 2.5-.217.746.679.833 1.864.203 2.654l-.001-.001Z"
      fill={fill}
    />
  </svg>
);

const Puzzle = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      d="m23.597 11.562-2.954-2.927A3.916 3.916 0 0 0 22.8 4.912a3.924 3.924 0 0 0-7.444-1.565L12.48.391a1.371 1.371 0 0 0-1.919 0L7.578 3.357a.48.48 0 0 0 .211.806c.672.176 1.26.584 1.66 1.152a2.995 2.995 0 0 1-.106 3.55 2.953 2.953 0 0 1-5.18-1.074.48.48 0 0 0-.805-.212L.403 10.555a1.344 1.344 0 0 0 0 1.919l2.955 2.879a3.926 3.926 0 0 0 3.597 6.976 3.925 3.925 0 0 0 1.688-1.688l2.877 2.956c.52.53 1.37.538 1.9.02l.019-.02 2.964-2.966a.48.48 0 0 0-.211-.806 2.944 2.944 0 0 1-1.66-1.151 2.995 2.995 0 0 1 .106-3.551 2.953 2.953 0 0 1 5.18 1.075.48.48 0 0 0 .335.335.479.479 0 0 0 .46-.124l2.984-2.975c.53-.52.538-1.37.02-1.9l-.02-.02v.048Z"
      fill={fill}
    />
  </svg>
);

const Approval = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" fill="none">
    <path
      fill={fill}
      fillRule="evenodd"
      d="M3 0h12a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Zm4.5 3.5h3a1.5 1.5 0 0 1 0 3h-1v1h3.7a1.3 1.3 0 0 1 1.3 1.3v.45h.5a1.5 1.5 0 0 1 0 3h-.5v.45a1.3 1.3 0 0 1-1.3 1.3H9.5v1.5h1a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 1 0-3h1V14H4.8a1.3 1.3 0 0 1-1.3-1.3v-.45H3a1.5 1.5 0 0 1 0-3h.5V8.8a1.3 1.3 0 0 1 1.3-1.3h3.7v-1h-1a1.5 1.5 0 1 1 0-3Zm6 5.3v.45H12a1.5 1.5 0 0 0 0 3h1.5v.45a.3.3 0 0 1-.3.3H4.8a.3.3 0 0 1-.3-.3v-.45H6a1.5 1.5 0 0 0 0-3H4.5V8.8a.3.3 0 0 1 .3-.3h8.4a.3.3 0 0 1 .3.3Z"
      clipRule="evenodd"
    />
  </svg>
);

const Sign = ({ fill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    viewBox="0 0 24 24"
    className="panelIcon"
    width={"24px"}
    height={"24px"}
  >
    <path
      fillRule="evenodd"
      d="M13.876 4.942 9.293 6.086A1.487 1.487 0 0 0 8.208 7.18l-2.334 9.64c-.07.292.287.492.5.28l5.108-5.109a1.86 1.86 0 1 1 .526.526l-5.109 5.109c-.212.212-.011.57.28.5l9.64-2.335c.538-.13.959-.548 1.093-1.085l1.144-4.583a1.487 1.487 0 0 0-.392-1.412l-3.376-3.377a1.487 1.487 0 0 0-1.412-.39Zm1.758-.463a1.11 1.11 0 0 1 0-1.571l.582-.583a1.11 1.11 0 0 1 1.57 0l3.889 3.888a1.11 1.11 0 0 1 0 1.571l-.583.582a1.11 1.11 0 0 1-1.57 0L15.633 4.48Z"
      clipRule="evenodd"
    ></path>
    <path
      fillRule="evenodd"
      d="M4.754 15.59a.6.6 0 0 1-.659 1.002l-.005-.001c-.003 0-.019-.005-.056.015a.285.285 0 0 0-.057.04c0 .007-.001.02.001.042.016.146.104.357.274.706l.043.087c.143.29.323.656.422 1.022.029.11.053.226.067.346.24.041.48.128.692.287.379.285.468.703.502.948v-.002l.031-.063c.092-.19.217-.449.376-.666.183-.25.474-.536.92-.605.535-.082.943.132 1.23.431.245.256.421.596.553.848l.011.023c.153.294.26.495.383.63.097.11.156.125.23.12.11-.006.26-.057.45-.183.184-.122.37-.29.54-.473a5.588 5.588 0 0 0 .556-.702l.006-.01a.6.6 0 0 1 1.014.642v.001l-.002.002-.003.005-.011.017a4.237 4.237 0 0 1-.18.259 6.76 6.76 0 0 1-.504.607 4.355 4.355 0 0 1-.754.653c-.286.19-.643.358-1.043.38-.534.031-.923-.216-1.192-.516-.232-.258-.404-.59-.534-.839l-.02-.039c-.152-.293-.256-.479-.367-.595-.076-.08-.111-.085-.18-.075-.004 0-.013.002-.032.016a.51.51 0 0 0-.102.111 3.33 3.33 0 0 0-.27.493l-.027.054-.006.013c-.093.191-.24.491-.456.693a.972.972 0 0 1-.541.264 1.03 1.03 0 0 1-.629-.133c-.52-.288-.588-.818-.617-1.048a1.508 1.508 0 0 0-.056-.303.494.494 0 0 0-.245-.071l-.108.191-.129.227c-.11.192-.243.412-.39.598-.127.162-.348.41-.663.5a.857.857 0 0 1-.585-.036 1.042 1.042 0 0 1-.42-.349 1.058 1.058 0 0 1-.21-.689c.012-.239.105-.445.215-.608.216-.316.559-.557.896-.72.15-.072.309-.135.474-.186a1.333 1.333 0 0 0-.03-.136c-.066-.247-.193-.508-.348-.824l-.035-.07c-.148-.303-.348-.712-.39-1.107a1.262 1.262 0 0 1 .117-.703 1.3 1.3 0 0 1 .55-.554 1.267 1.267 0 0 1 1.168-.045 1.102 1.102 0 0 1 .115.064l.012.008.004.003.003.002.001.001Zm-.776 1.048v.002Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const Mobile = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 32 36"
    fill="none"
  >
    <g clipPath="url(#clip0_344_32)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4941 2.48138e-05H7.20891C6.8616 2.15606e-05 6.51771 0.0679998 6.19699 0.200057C5.87626 0.332115 5.58501 0.52565 5.33996 0.769553C5.0949 1.01346 4.90088 1.30292 4.76901 1.62134C4.63715 1.93975 4.57005 2.28084 4.57156 2.62502V33.3863C4.57156 34.0795 4.84942 34.7443 5.34402 35.2345C5.83862 35.7246 6.50944 36 7.20891 36H22.4941C22.8414 36.0015 23.1856 35.935 23.5069 35.8043C23.8282 35.6736 24.1203 35.4813 24.3664 35.2385C24.6125 34.9956 24.8078 34.707 24.9411 34.3892C25.0743 34.0713 25.1429 33.7305 25.1429 33.3863V21H23.1592V29.1704H6.54384V4.43184H23.1592V5H25.1429V2.62502C25.1445 2.27988 25.077 1.93786 24.9444 1.6187C24.8118 1.29954 24.6168 1.00957 24.3705 0.765515C24.1242 0.521462 23.8316 0.328163 23.5096 0.196778C23.1875 0.0653918 22.8424 -0.00147909 22.4941 2.48138e-05ZM14.2512 33.51C14.1354 33.3968 14.0433 33.2621 13.98 33.1136C13.8523 32.8137 13.85 32.4759 13.9737 32.1743C14.0973 31.8728 14.3368 31.6322 14.6394 31.5057C14.942 31.3791 15.2829 31.3768 15.5872 31.4993C15.8915 31.6219 16.1342 31.8592 16.2619 32.1591C16.3252 32.3076 16.3583 32.4669 16.3594 32.6281C16.3605 32.7893 16.3295 32.9491 16.2683 33.0984C16.2071 33.2477 16.1168 33.3836 16.0025 33.4983C15.8883 33.613 15.7524 33.7043 15.6026 33.767C15.4528 33.8297 15.2919 33.8625 15.1293 33.8636C14.9667 33.8647 14.8054 33.834 14.6548 33.7733C14.5041 33.7127 14.367 33.6232 14.2512 33.51Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2862 9.00012C17.0238 9.00012 16.0005 10.0075 16.0005 11.2501V18.0001C16.0005 19.2428 17.0238 20.2501 18.2862 20.2501H19.4291V23.6251L22.8576 20.2501H29.7148C30.9771 20.2501 32.0005 19.2428 32.0005 18.0001V11.2501C32.0005 10.0075 30.9771 9.00012 29.7148 9.00012H18.2862ZM19.4291 11.2501C18.7979 11.2501 18.2862 11.7538 18.2862 12.3751C18.2862 12.9964 18.7979 13.5001 19.4291 13.5001H28.5719C29.2031 13.5001 29.7148 12.9964 29.7148 12.3751C29.7148 11.7538 29.2031 11.2501 28.5719 11.2501H19.4291ZM18.2862 16.8751C18.2862 16.2538 18.7979 15.7501 19.4291 15.7501H24.0005C24.6317 15.7501 25.1433 16.2538 25.1433 16.8751C25.1433 17.4964 24.6317 18.0001 24.0005 18.0001H19.4291C18.7979 18.0001 18.2862 17.4964 18.2862 16.8751Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_344_32">
        <rect width="32" height="36" fill={fill} />
      </clipPath>
    </defs>
  </svg>
);

const Message = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 32 36"
    fill="none"
  >
    <g clipPath="url(#clip0_344_32)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4941 2.48138e-05H7.20891C6.8616 2.15606e-05 6.51771 0.0679998 6.19699 0.200057C5.87626 0.332115 5.58501 0.52565 5.33996 0.769553C5.0949 1.01346 4.90088 1.30292 4.76901 1.62134C4.63715 1.93975 4.57005 2.28084 4.57156 2.62502V33.3863C4.57156 34.0795 4.84942 34.7443 5.34402 35.2345C5.83862 35.7246 6.50944 36 7.20891 36H22.4941C22.8414 36.0015 23.1856 35.935 23.5069 35.8043C23.8282 35.6736 24.1203 35.4813 24.3664 35.2385C24.6125 34.9956 24.8078 34.707 24.9411 34.3892C25.0743 34.0713 25.1429 33.7305 25.1429 33.3863V21H23.1592V29.1704H6.54384V4.43184H23.1592V5H25.1429V2.62502C25.1445 2.27988 25.077 1.93786 24.9444 1.6187C24.8118 1.29954 24.6168 1.00957 24.3705 0.765515C24.1242 0.521462 23.8316 0.328163 23.5096 0.196778C23.1875 0.0653918 22.8424 -0.00147909 22.4941 2.48138e-05ZM14.2512 33.51C14.1354 33.3968 14.0433 33.2621 13.98 33.1136C13.8523 32.8137 13.85 32.4759 13.9737 32.1743C14.0973 31.8728 14.3368 31.6322 14.6394 31.5057C14.942 31.3791 15.2829 31.3768 15.5872 31.4993C15.8915 31.6219 16.1342 31.8592 16.2619 32.1591C16.3252 32.3076 16.3583 32.4669 16.3594 32.6281C16.3605 32.7893 16.3295 32.9491 16.2683 33.0984C16.2071 33.2477 16.1168 33.3836 16.0025 33.4983C15.8883 33.613 15.7524 33.7043 15.6026 33.767C15.4528 33.8297 15.2919 33.8625 15.1293 33.8636C14.9667 33.8647 14.8054 33.834 14.6548 33.7733C14.5041 33.7127 14.367 33.6232 14.2512 33.51Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2862 9.00012C17.0238 9.00012 16.0005 10.0075 16.0005 11.2501V18.0001C16.0005 19.2428 17.0238 20.2501 18.2862 20.2501H19.4291V23.6251L22.8576 20.2501H29.7148C30.9771 20.2501 32.0005 19.2428 32.0005 18.0001V11.2501C32.0005 10.0075 30.9771 9.00012 29.7148 9.00012H18.2862ZM19.4291 11.2501C18.7979 11.2501 18.2862 11.7538 18.2862 12.3751C18.2862 12.9964 18.7979 13.5001 19.4291 13.5001H28.5719C29.2031 13.5001 29.7148 12.9964 29.7148 12.3751C29.7148 11.7538 29.2031 11.2501 28.5719 11.2501H19.4291ZM18.2862 16.8751C18.2862 16.2538 18.7979 15.7501 19.4291 15.7501H24.0005C24.6317 15.7501 25.1433 16.2538 25.1433 16.8751C25.1433 17.4964 24.6317 18.0001 24.0005 18.0001H19.4291C18.7979 18.0001 18.2862 17.4964 18.2862 16.8751Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_344_32">
        <rect width="32" height="36" fill={fill} />
      </clipPath>
    </defs>
  </svg>
);

const EmailNotofication = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
    viewBox="0 0 24 24"
    width="20"
    height="20"
  >
    <path
      fillRule="white"
      d="M1 18V7.52l9.28 6.496a3 3 0 0 0 3.44 0l.16-.111c.007.122.022.243.044.363a5.004 5.004 0 0 0-1.016 3.87l.006.055c.007.074.016.178.024.295.02.251.033.507.032.673-.003.38-.088.966-.19 1.508a2.36 2.36 0 0 0-.041.33H4a3 3 0 0 1-3-3Zm22-1.472V7.521l-4.931 3.451a3 3 0 0 1 1.633 1.75 5 5 0 0 1 2.81 2.84l.023.05c.031.068.075.162.126.268a9.278 9.278 0 0 0 .339.648ZM20 3a3 3 0 0 1 2.881 2.162l-10.308 7.216a1 1 0 0 1-1.146 0L1.119 5.162A3.001 3.001 0 0 1 4 3h16Zm-4.326 11.624a3.5 3.5 0 0 0-1.277 3.322l.001.016.01.094.026.319c.02.258.038.565.036.797-.004.524-.112 1.223-.217 1.777-.137.72.52 1.38 1.259 1.182l.891-.24a2.123 2.123 0 0 0 2.419 1.04 2.127 2.127 0 0 0 1.575-2.108l1.857-.498c.737-.197.977-1.096.501-1.65-.368-.429-.812-.983-1.079-1.438-.117-.2-.255-.473-.367-.706a20.175 20.175 0 0 1-.175-.374l-.007-.015a3.5 3.5 0 0 0-2.764-2.238 1.502 1.502 0 0 0-1.006-1.6 1.5 1.5 0 0 0-1.683 2.32Zm.885-.512a.5.5 0 1 1 .782-.209 3.508 3.508 0 0 0-.782.21Zm.867 7.51a1.123 1.123 0 0 0 1.531.148 1.125 1.125 0 0 0 .419-.671l-1.95.522Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const AutoEmail = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
    viewBox="0 0 24 24"
    width="20"
    height="20"
  >
    <path d="M21.707 5.121a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 1 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.414 0ZM2.293 3.707a1 1 0 0 0 1.414 1.414l1.414-1.414a1 1 0 1 0-1.414-1.414L2.293 3.707Z"></path>
    <path
      fillRule="evenodd"
      d="M12 3C6.477 3 2 7.477 2 13s4.477 10 10 10 10-4.477 10-10S17.523 3 12 3Zm3.957 8.707a1 1 0 0 0-1.414-1.414l-3.793 3.793-1.293-1.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const DigestEmail = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
    viewBox="0 0 24 24"
    width="20"
    height="20"
  >
    <path d="M11.39 14.167a1.1 1.1 0 0 0-.18 1.319l3.933 6.955a1.1 1.1 0 0 0 2.001-.193l5.83-18.87c.171-.557-.528-.964-.927-.54L11.39 14.167Zm-6.552 3.499.496-3.485a.66.66 0 0 1 1.12-.373l3.736 3.734a.66.66 0 0 1-.373 1.12l-3.486.497a1.32 1.32 0 0 1-1.493-1.493ZM1.005 7.792a1.1 1.1 0 0 1 .747-.938l18.876-5.827c.557-.172.963.526.539.926L9.835 12.606a1.1 1.1 0 0 1-1.319.18L1.56 8.855a1.1 1.1 0 0 1-.554-1.063Z"></path>
  </svg>
);

const ConditionPage = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white">
    <path
      fillRule="white"
      d="M16 5a4.001 4.001 0 0 1-2.5 3.71v2.79h4A1.5 1.5 0 0 1 19 13v4h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2v-2.5H8V17h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2v-4a1.5 1.5 0 0 1 1.5-1.5h4V8.71A4.001 4.001 0 0 1 12 1a4 4 0 0 1 4 4Z"
      fill="#fff"
      clipRule="evenodd"
    />
  </svg>
);

const PreviewCondition = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      fillRule="evenodd"
      d="M12 4C9.277 4 7.031 5.239 5.33 6.698c-1.7 1.458-2.89 3.164-3.512 4.174-.43.697-.43 1.56 0 2.256.623 1.01 1.812 2.716 3.512 4.174C7.032 18.762 9.278 20 12 20c2.72 0 4.967-1.239 6.668-2.698 1.7-1.458 2.89-3.164 3.513-4.174a2.138 2.138 0 0 0 0-2.256c-.623-1.01-1.812-2.716-3.513-4.174C16.968 5.238 14.721 4 12 4Zm0 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm2-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const PreviewCalculate = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      fillRule="evenodd"
      d="M7 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H7Zm.5 17a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5ZM7 14.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm.5-4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM8 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8Zm3 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm4.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-4 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const PreviewEnable = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      fillRule="evenodd"
      d="M12 4a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L14 12l4.562 2.634a1 1 0 0 1-1 1.732L13 13.732V19a1 1 0 1 1-2 0v-5.268l-4.563 2.634a1 1 0 1 1-1-1.732L10 12 5.437 9.366a1 1 0 0 1 1-1.732L11 10.268V5a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const PreviewSkip = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      fillRule="evenodd"
      d="M16 7V3.499a.5.5 0 0 1 .896-.305l5.893 7.655a1 1 0 0 1-.04 1.269l-5.873 6.71A.5.5 0 0 1 16 18.5V15c-.023-.01-3.492-1.592-7.5-.499-3.003.82-5.145 3.731-6.47 6.207-.28.52-1.144.283-1.016-.294C1.778 16.959 3.44 12.17 7 9.5 10.325 7.007 15.97 7 16 7Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const PreviewConfirm = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      fillRule="evenodd"
      d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm5.707-13.293a1 1 0 0 0-1.414-1.414L11 13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l6-6Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const PreviewMessage = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      fillRule="evenodd"
      d="M1 7.52V18a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7.52l-9.28 6.496a3 3 0 0 1-3.44 0L1 7.521Zm21.881-2.358A3.001 3.001 0 0 0 20 3H4a3.001 3.001 0 0 0-2.881 2.162l10.308 7.216a1 1 0 0 0 1.146 0l10.308-7.216Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const ArrowCondition = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#c8ceed"
    viewBox="0 0 24 24"
    width="18"
    height="18"
  >
    <path
      fillRule="evenodd"
      d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm-1.707-7.707a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 1 0-1.414 1.414L13.586 12l-3.293 3.293Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const GeneralSetting = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none">
    <path
      d="M20.781 8.125 22.5 4.844l-2.188-2.188-3.28 1.719c-.47-.313-1.095-.469-1.72-.625L14.063 0h-3.124l-1.25 3.594c-.47.156-1.094.312-1.563.625L4.844 2.5 2.5 4.844l1.719 3.281c-.313.469-.469 1.094-.625 1.563L0 10.938v3.124l3.594 1.25c.156.626.469 1.094.625 1.72L2.5 20.311 4.688 22.5l3.28-1.719c.47.313 1.095.469 1.72.625L10.938 25h3.124l1.25-3.594c.626-.156 1.094-.468 1.72-.625l3.28 1.719 2.188-2.188-1.719-3.28c.313-.47.469-1.095.625-1.72L25 14.063v-3.124l-3.594-1.25c-.156-.47-.312-1.094-.625-1.563ZM12.5 17.188c-2.656 0-4.688-2.032-4.688-4.688 0-2.656 2.032-4.688 4.688-4.688 2.656 0 4.688 2.032 4.688 4.688 0 2.656-2.032 4.688-4.688 4.688Z"
      fill="#fff"
    />
  </svg>
);

const EnableFormSetting = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    viewBox="0 0 24 24"
    width="20"
    height="20"
  >
    <path
      fillRule="evenodd"
      d="M21 20v-6.5a7.46 7.46 0 0 1-3.918 1.478A1.14 1.14 0 0 1 16.36 17H7.64a1.14 1.14 0 0 1 0-2.28h6.823a7.484 7.484 0 0 1-2.907-1.58H7.64a1.14 1.14 0 0 1 0-2.28h2.153a7.448 7.448 0 0 1-.58-1.58H7.64a1.14 1.14 0 0 1 0-2.28h1.376a7.5 7.5 0 0 1 3.74-6H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3Zm1-12.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-2.293-2.207a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414 0l-1.5-1.5a1 1 0 0 1 1.414-1.414l.793.793 2.293-2.293a1 1 0 0 1 1.414 0Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const SettingFormStatus = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={"20px"}
    height={"20px"}
    fill={fill}
    viewBox="0 0 24 24"
    className="color-white w-5 h-5"
    role="presentation"
  >
    <path
      fillRule="evenodd"
      d="M6 1h12a3 3 0 0 1 3 3v9.757l-.879-.878a2.996 2.996 0 0 0-2.622-.837L17.5 12c0-.63-.51-1.14-1.14-1.14H7.64a1.14 1.14 0 0 0 0 2.28h8.006a2.987 2.987 0 0 0-.633 1.58H7.64a1.14 1.14 0 0 0 0 2.28h4.53A3 3 0 0 0 15 21c0 .716.255 1.432.764 2H6a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3Zm1.64 6a1.14 1.14 0 0 0 0 2.28h8.72a1.14 1.14 0 0 0 0-2.28H7.64ZM15 17a1 1 0 1 0 0 2h3.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 0 0-1.414 1.414L18.586 17H15Z"
      clipRule="evenodd"
    ></path>
  </svg>
);

const SettingApproval = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M3 0h12a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Zm4.5 3.5h3a1.5 1.5 0 0 1 0 3h-1v1h3.7a1.3 1.3 0 0 1 1.3 1.3v.45h.5a1.5 1.5 0 0 1 0 3h-.5v.45a1.3 1.3 0 0 1-1.3 1.3H9.5v1.5h1a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 1 0-3h1V14H4.8a1.3 1.3 0 0 1-1.3-1.3v-.45H3a1.5 1.5 0 0 1 0-3h.5V8.8a1.3 1.3 0 0 1 1.3-1.3h3.7v-1h-1a1.5 1.5 0 1 1 0-3Zm6 5.3v.45H12a1.5 1.5 0 0 0 0 3h1.5v.45a.3.3 0 0 1-.3.3H4.8a.3.3 0 0 1-.3-.3v-.45H6a1.5 1.5 0 0 0 0-3H4.5V8.8a.3.3 0 0 1 .3-.3h8.4a.3.3 0 0 1 .3.3Z"
      clipRule="evenodd"
    />
  </svg>
);

const SettingThankYouPage = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    width={"24px"}
    height={"24px"}
    viewBox="0 0 24 24"
    className="thankyou-settings-icon"
  >
    <path d="M21.81 10.328a2.75 2.75 0 0 1-1.69-4.082c.442-.737.309-1.373-.13-1.81l-.426-.426c-.437-.437-1.073-.57-1.81-.13a2.75 2.75 0 0 1-4.082-1.69C13.464 1.354 12.92 1 12.302 1h-.603c-.619 0-1.162.355-1.371 1.19a2.75 2.75 0 0 1-4.082 1.69c-.737-.442-1.374-.309-1.811.128l-.426.427c-.438.437-.571 1.074-.128 1.81a2.75 2.75 0 0 1-1.692 4.083c-.832.208-1.189.75-1.189 1.37v.603c0 .619.355 1.162 1.19 1.371a2.75 2.75 0 0 1 1.69 4.082c-.442.737-.309 1.373.13 1.81l.426.426c.439.439 1.075.57 1.81.13a2.749 2.749 0 0 1 4.082 1.69c.208.835.752 1.19 1.37 1.19h.603c.619 0 1.162-.355 1.371-1.19a2.75 2.75 0 0 1 4.082-1.69c.736.44 1.371.309 1.81-.13l.426-.426c.437-.437.57-1.073.13-1.81a2.749 2.749 0 0 1 1.69-4.082c.835-.208 1.19-.752 1.19-1.37v-.603c0-.62-.358-1.163-1.19-1.371ZM12 16.125a4.125 4.125 0 1 1 0-8.25 4.125 4.125 0 0 1 0 8.25Z"></path>
  </svg>
);

const LinkSetting = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      d="M13.567 1.4c-.062.072-.086.103-.113.13-1.346 1.356-2.69 2.712-4.037 4.067-.747.752-1.498 1.5-2.241 2.257-.313.319-.307.713-.006 1.012.276.273.7.257 1-.041.479-.476.955-.954 1.433-1.43l4.825-4.82c.044-.044.094-.081.167-.144v.249c0 .772-.002 1.544 0 2.316.002.302.165.558.406.652.488.19.987-.136.992-.682.013-1.407.004-2.815.006-4.223 0-.333-.389-.745-.733-.743-1.433.01-2.866.002-4.299.006-.378.001-.653.277-.675.65a.68.68 0 00.581.721c.106.017.214.022.322.022.719.002 1.438.001 2.157.001h.215M7.243 15.994h4.248c.514 0 1.001-.118 1.444-.38 1.018-.602 1.551-1.5 1.559-2.688.01-1.629.002-3.258.002-4.887 0-.102.002-.205-.006-.306a.652.652 0 00-.293-.513.68.68 0 00-.739-.037c-.246.133-.362.348-.362.628 0 1.697-.006 3.394.003 5.091a1.663 1.663 0 01-1.68 1.69 665.622 665.622 0 00-8.36 0 1.648 1.648 0 01-1.654-1.66c.004-2.81 0-5.62.003-8.43 0-.134.018-.272.05-.403.188-.746.833-1.228 1.65-1.23 1.672-.002 3.342 0 5.013-.001a.994.994 0 00.284-.03.68.68 0 00.473-.769c-.053-.36-.333-.601-.709-.602-1.727 0-3.455-.015-5.182.005C1.91 1.485 1.066 1.98.472 2.88.125 3.405-.002 3.991 0 4.624.011 7.383.021 10.14 0 12.9c-.013 1.708 1.37 3.133 3.098 3.1 1.381-.028 2.763-.006 4.145-.006"
      fill="#5E74E6"
      fillRule="evenodd"
    />
  </svg>
);



const UploadSetting = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={'20px'} height={'20px'} fill={fill} viewBox="0 0 24 24" className="magnet-button-icon shrink-0 w-5 h-5"><path fillRule="evenodd" d="M13 3a1 1 0 1 0-2 0v11.586l-4.293-4.293a1 1 0 1 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0-1.414-1.414L13 14.586V3ZM2 21a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z" clipRule="evenodd"></path></svg>

);



const Warning = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 24 24" width="24px"><path fillRule="evenodd" d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11 3a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" clipRule="evenodd"></path></svg>

);



const EmailLink = () => (
  <svg width={'10px'} height={'10px'} xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" className="formFields-icon"><path fillRule="evenodd" d="M17.959 6.04a3.714 3.714 0 0 1 0 5.253l-1.334 1.334a1 1 0 0 0 1.415 1.414l1.333-1.334a5.714 5.714 0 1 0-8.08-8.08L9.958 5.96a1 1 0 1 0 1.414 1.414l1.333-1.333a3.714 3.714 0 0 1 5.253 0Zm-10 10a1 1 0 0 1 0-1.414l6.667-6.667a1 1 0 1 1 1.414 1.414L9.374 16.04a1 1 0 0 1-1.415 0ZM6.04 12.707a3.714 3.714 0 0 0 5.252 5.252l1.334-1.333a1 1 0 1 1 1.414 1.414l-1.333 1.333a5.714 5.714 0 1 1-8.081-8.08l1.333-1.334a1 1 0 1 1 1.414 1.414L6.04 12.707Z" clipRule="evenodd"></path></svg>

);


const Hide = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="16" height="16"><path fill-rule="evenodd" d="M3.293 3.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414Zm13.046 14.461.728.728C15.636 19.372 13.938 20 12 20c-2.721 0-4.967-1.239-6.669-2.698-1.7-1.458-2.89-3.164-3.512-4.174a2.136 2.136 0 0 1 0-2.256c.62-1.005 1.8-2.699 3.487-4.152l.71.709 2.538 2.54a4 4 0 0 0 5.478 5.478l2.308 2.307Zm-.347-6a4 4 0 0 0-3.747-3.747L9.211 4.973l-.39-.39A9.032 9.032 0 0 1 11.998 4c2.722 0 4.968 1.239 6.67 2.698 1.7 1.458 2.89 3.164 3.512 4.174.429.697.429 1.56 0 2.256a19.216 19.216 0 0 1-2.061 2.754l-.354-.354-3.774-3.774Zm-5.925-.272a2 2 0 0 0 2.45 2.45l-2.45-2.45Z" clip-rule="evenodd"></path></svg>
);



const Show = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="16" height="16"><path fill-rule="evenodd" d="M12 4C9.277 4 7.031 5.239 5.33 6.698c-1.7 1.458-2.89 3.164-3.512 4.174-.43.697-.43 1.56 0 2.256.623 1.01 1.812 2.716 3.512 4.174C7.032 18.762 9.278 20 12 20c2.72 0 4.967-1.239 6.668-2.698 1.7-1.458 2.89-3.164 3.513-4.174a2.138 2.138 0 0 0 0-2.256c-.623-1.01-1.812-2.716-3.513-4.174C16.968 5.238 14.721 4 12 4Zm0 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm2-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" clip-rule="evenodd"></path></svg>
);



const Calculate = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="16" height="16"><path fill-rule="evenodd" d="M7 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H7Zm.5 17a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5ZM7 14.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm.5-4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM8 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8Zm3 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm4.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-4 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Z" clip-rule="evenodd"></path></svg>
);


const Require = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="16" height="16"><path fill-rule="evenodd" d="M12 4a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L14 12l4.562 2.634a1 1 0 0 1-1 1.732L13 13.732V19a1 1 0 1 1-2 0v-5.268l-4.563 2.634a1 1 0 1 1-1-1.732L10 12 5.437 9.366a1 1 0 0 1 1-1.732L11 10.268V5a1 1 0 0 1 1-1Z" clip-rule="evenodd"></path></svg>
);



const ConditionArrow = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="16" height="16"><path fill-rule="evenodd" d="M14.707 6.293a1 1 0 1 0-1.414 1.414L16.586 11H5a1 1 0 1 0 0 2h11.586l-3.293 3.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5Z" clip-rule="evenodd"></path></svg>

);



const ConditionSetting = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="20px" height="20px" class="magnet-button-icon shrink-0 w-5 h-5"><path d="M21.81 10.328a2.75 2.75 0 0 1-1.69-4.082c.442-.737.309-1.373-.13-1.81l-.426-.426c-.437-.437-1.073-.57-1.81-.13a2.75 2.75 0 0 1-4.082-1.69C13.464 1.354 12.92 1 12.302 1h-.603c-.619 0-1.162.355-1.371 1.19a2.75 2.75 0 0 1-4.082 1.69c-.737-.442-1.374-.309-1.811.128l-.426.427c-.438.437-.571 1.074-.128 1.81a2.75 2.75 0 0 1-1.692 4.083c-.832.208-1.189.75-1.189 1.37v.603c0 .619.355 1.162 1.19 1.371a2.75 2.75 0 0 1 1.69 4.082c-.442.737-.309 1.373.13 1.81l.426.426c.439.439 1.075.57 1.81.13a2.749 2.749 0 0 1 4.082 1.69c.208.835.752 1.19 1.37 1.19h.603c.619 0 1.162-.355 1.371-1.19a2.75 2.75 0 0 1 4.082-1.69c.736.44 1.371.309 1.81-.13l.426-.426c.437-.437.57-1.073.13-1.81a2.749 2.749 0 0 1 1.69-4.082c.835-.208 1.19-.752 1.19-1.37v-.603c0-.62-.358-1.163-1.19-1.371ZM12 16.125a4.125 4.125 0 1 1 0-8.25 4.125 4.125 0 0 1 0 8.25Z"></path></svg>

);



const CloseSetting = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="20px" height="20px" class="magnet-button-icon shrink-0 w-5 h-5"><path fill-rule="evenodd" d="M17.707 7.707a1 1 0 0 0-1.414-1.414L12 10.586 7.707 6.293a1 1 0 0 0-1.414 1.414L10.586 12l-4.293 4.293a1 1 0 1 0 1.414 1.414L12 13.414l4.293 4.293a1 1 0 0 0 1.414-1.414L13.414 12l4.293-4.293Z" clip-rule="evenodd"></path></svg>
);


const DeleteConditionSetting = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="24px" height="24px"><path fill-rule="evenodd" d="M4 5h16a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-2.764c-.55-.614-1.348-1-2.236-1H9a2.99 2.99 0 0 0-2.236 1H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm.036 1.534A.5.5 0 0 1 4.535 6h14.93a.5.5 0 0 1 .5.534l-.92 13.667A3 3 0 0 1 16.052 23H7.948a3 3 0 0 1-2.993-2.799l-.92-13.667ZM10 11a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1Zm4 0a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1Z" clip-rule="evenodd"></path></svg>
);




const DisableConditionSetting = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="24px" height="24px"><path fill-rule="evenodd" d="M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7Zm8 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2Z" clip-rule="evenodd"></path></svg>
);


const EnableConditionSetting = ({ fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24"><path fill-rule="evenodd" d="M13.76 4.056c-.753-1.413-2.778-1.412-3.53 0L2.24 19.06l.882.47-.883-.47C1.53 20.392 2.495 22 4.005 22h15.988c1.51 0 2.475-1.608 1.765-2.94L13.76 4.056Z" clip-rule="evenodd"></path></svg>

);


const Division = () => (
  <svg height="15px" width="15px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16">
    <g>
      <path style={{ fill: '#FFF' }} d="M16,9c0,0.553-0.447,1-1,1H1c-0.553,0-1-0.447-1-1V7c0-0.552,0.447-1,1-1h14c0.553,0,1,0.448,1,1V9z
		"/>
      <path style={{ fill: '#FFF' }} d="M7,4C6.447,4,6,3.553,6,3V1c0-0.553,0.447-1,1-1h2c0.553,0,1,0.447,1,1v2c0,0.553-0.447,1-1,1H7z" />
      <path style={{ fill: '#FFF' }} d="M7,16c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1h2c0.553,0,1,0.447,1,1v2c0,0.553-0.447,1-1,1H7z
		"/>
    </g>
  </svg>
);



const TickSetting = ({ fill }) => (

  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" width="16" height="16"><path fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm5.707-13.293a1 1 0 0 0-1.414-1.414L11 13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l6-6Z" clip-rule="evenodd"></path></svg>

);



const EmailListSetting = ({ fill }) => (

  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" class="mail-envelope-icon" width="24"><path fill-rule="evenodd" d="M1 7.52V18a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7.52l-9.28 6.496a3 3 0 0 1-3.44 0L1 7.521Zm21.881-2.358A3.001 3.001 0 0 0 20 3H4a3.001 3.001 0 0 0-2.881 2.162l10.308 7.216a1 1 0 0 0 1.146 0l10.308-7.216Z" clip-rule="evenodd"></path></svg>

);



const ArrowEmailSetting = ({ fill }) => {

  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" class="mail-forward-icon" width="24"><path fill-rule={fill} d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm7.293 14.707a1 1 0 0 1 0-1.414L14.586 13H7a1 1 0 1 1 0-2h7.586l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0Z" clip-rule="evenodd"></path></svg>

}


const Function = ({ fill }) => {
  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" class="fnDropdown-fnIcon" width="16px" height="16px"><path fill-rule="white" d="M7 4a3 3 0 0 0-3 3v3H3a1 1 0 1 0 0 2h1v4a1 1 0 0 1-1 1 1 1 0 1 0 0 2 3 3 0 0 0 3-3v-4h1a1 1 0 1 0 0-2H6V7a1 1 0 0 1 1-1h1a1 1 0 0 0 0-2H7Zm5.302 5.597A1 1 0 0 0 12.1 8.2a1.006 1.006 0 0 0-1.405.206l-.006.009-.02.027a6.825 6.825 0 0 0-.261.403A10.224 10.224 0 0 0 9 14c0 1.667.416 3.052.83 4.019.209.485.418.869.578 1.136a6.805 6.805 0 0 0 .261.403l.028.038c.331.441.961.535 1.403.204.44-.33.525-.963.197-1.405a4.8 4.8 0 0 1-.174-.27 7.494 7.494 0 0 1-.454-.894A8.237 8.237 0 0 1 11 14a8.226 8.226 0 0 1 1.123-4.126 4.809 4.809 0 0 1 .174-.27l.005-.007Zm4.49 1.696a1 1 0 0 1 1.415 1.414L16.914 14l1.293 1.293a1 1 0 0 1-1.414 1.414L15.5 15.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L14.086 14l-1.293-1.293a1 1 0 0 1 1.414-1.414l1.293 1.293 1.293-1.293ZM18.9 8.2a1 1 0 0 0-.202 1.397l.005.007.034.049c.031.046.08.12.14.22A8.237 8.237 0 0 1 20 14a8.237 8.237 0 0 1-.67 3.232c-.166.39-.332.694-.453.895a4.8 4.8 0 0 1-.174.27A1.008 1.008 0 0 0 18.9 19.8a1.004 1.004 0 0 0 1.43-.242 6.805 6.805 0 0 0 .261-.403c.161-.268.37-.652.578-1.136.415-.967.831-2.352.831-4.019 0-1.667-.416-3.052-.83-4.019a9.472 9.472 0 0 0-.578-1.136 6.825 6.825 0 0 0-.261-.403l-.02-.027-.006-.009A1.006 1.006 0 0 0 18.9 8.2Z" clip-rule="evenodd"></path></svg>
}


const MainPageDrawer = ({ fill }) => {

  <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" class="magnet-button-icon shrink-0 w-5 h-5"><path fill-rule="evenodd" d="M12 7a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0 7.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm-2.5 5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z" clip-rule="evenodd"></path></svg>

}




const TemplateIcon = () => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 162 204" class="jfWizard-list-item-icon-svg" width="120" height="123"><rect width="162" height="204" rx="4" fill="#fff"></rect><rect x="9" y="9" width="144" height="46" rx="4" fill="#09F"></rect><circle cx="35" cy="28" r="11" fill="#FFB629"></circle><path d="M115.7 22.39 85 55h64l-28.871-32.544a3 3 0 0 0-4.429-.066Z" fill="#9EDC36"></path><path d="M89.754 29.875 66 55h50.5L94.174 29.94a3 3 0 0 0-4.42-.065Z" fill="#78BB07"></path><rect x="9" y="90" width="144" height="14" rx="7" fill="#C8C8E3"></rect><rect x="9" y="137" width="144" height="14" rx="7" fill="#C8C8E3"></rect><rect x="9" y="67" width="68" height="14" rx="7" fill="#E6E6F5"></rect><rect x="9" y="114" width="68" height="14" rx="7" fill="#E6E6F5"></rect></svg>
  )
}



const AddCreateForm = ({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" class="jfWizard-list-item-icon-svg" width="80" height="80"><path fill-rule="evenodd" d="M13 5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V5Z" clip-rule="evenodd"></path></svg>
  )
}




const ImportCreateForm = () => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 162 204" class="jfWizard-list-item-icon-svg" width="120" height="123"><rect width="162" height="204" rx="4" fill="#fff"></rect><rect x="9" y="9" width="144" height="46" rx="4" fill="#C8C8E3"></rect><rect x="9" y="90" width="144" height="14" rx="7" fill="#C8C8E3"></rect><rect x="9" y="137" width="60" height="14" rx="7" fill="#C8C8E3"></rect><rect x="9" y="67" width="144" height="14" rx="7" fill="#E6E6F5"></rect><rect x="9" y="114" width="60" height="14" rx="7" fill="#E6E6F5"></rect><circle cx="118" cy="156" r="35" fill="#09F"></circle><path d="M118.5 174c.82 0 1.367-.269 1.914-.806l13.637-13.393a2.682 2.682 0 1 0-3.759-3.828l-9.058 8.896v-25.135a2.734 2.734 0 1 0-5.468 0v25.135l-9.058-8.896a2.682 2.682 0 1 0-3.759 3.828l13.637 13.393c.547.537 1.094.806 1.914.806Z" fill="#fff"></path></svg>
  )
}


const ClassicForm = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121 125" class="jfWizard-list-item-icon-svg" width='90px' height='105px'><g fill="none" fill-rule="evenodd"><path d="M4.417 0h112a4 4 0 014 4v121h-120V4a4 4 0 014-4z" fill="#FFF" fill-rule="nonzero"></path><g transform="translate(10.417 13)"><path d="M17.001 31.122h79.14a2.858 2.858 0 010 5.716h-79.14a2.858 2.858 0 110-5.716z" fill="#DAE2ED" fill-rule="nonzero"></path><rect fill="#DAE2ED" fill-rule="nonzero" y="20.324" width="74.571" height="5.716" rx="2.858"></rect><rect fill="#DAE2ED" fill-rule="nonzero" width="99" height="8.257" rx="3"></rect><path d="M17.001 41.284h79.14a2.858 2.858 0 010 5.716h-79.14a2.858 2.858 0 110-5.716z" fill="#DAE2ED" fill-rule="nonzero"></path><g transform="translate(0 30.486)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.429" height="6.351" rx="2"></rect><path d="M2.734 4.765a.33.33 0 01-.238-.103L1.304 3.424a.36.36 0 010-.495.328.328 0 01.477 0l.953.99L4.878 1.69a.328.328 0 01.477 0 .36.36 0 010 .496L2.972 4.662a.33.33 0 01-.238.103" fill="#FFF"></path></g><rect fill="#DAE2ED" fill-rule="nonzero" y="40.649" width="6.429" height="6.351" rx="2"></rect></g><g transform="translate(10.417 72)"><path d="M17.036 10.929h79.071a2.893 2.893 0 010 5.785H17.036a2.893 2.893 0 110-5.785zM2.893 0h68.786a2.893 2.893 0 110 5.786H2.893a2.893 2.893 0 010-5.786zM17.036 21.214h79.071a2.893 2.893 0 010 5.786H17.036a2.893 2.893 0 110-5.786z" fill="#DAE2ED" fill-rule="nonzero"></path><g transform="translate(0 10.286)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.429" height="6.429" rx="2"></rect><path d="M2.734 4.823a.327.327 0 01-.238-.104L1.304 3.465a.367.367 0 010-.5.325.325 0 01.477 0l.953 1.002L4.878 1.71a.325.325 0 01.477 0 .367.367 0 010 .501L2.972 4.72a.328.328 0 01-.238.104" fill="#FFF"></path></g><rect fill="#DAE2ED" fill-rule="nonzero" y="20.571" width="6.429" height="6.429" rx="2"></rect><g transform="translate(0 20.571)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.429" height="6.429" rx="2"></rect><path d="M2.734 4.823a.327.327 0 01-.238-.104L1.304 3.465a.367.367 0 010-.5.325.325 0 01.477 0l.953 1.002L4.878 1.71a.325.325 0 01.477 0 .367.367 0 010 .501L2.972 4.72a.328.328 0 01-.238.104" fill="#FFF"></path></g></g><rect fill="#2F90FF" fill-rule="nonzero" x="77.417" y="109" width="32" height="10" rx="4"></rect></g></svg>
  )
}


const CardForm = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121 92" class="jfWizard-list-item-icon-svg" width='100px' height='90px'><g fill="none" fill-rule="evenodd"><rect fill="#FFF" fill-rule="nonzero" x="7.934" width="105.131" height="62.153" rx="4"></rect><path d="M7.934 49.59h105.132v9.224a4 4 0 01-4 4H11.934a4 4 0 01-4-4V49.59z" fill="#2A5ACA" fill-rule="nonzero"></path><g transform="translate(15.208 11.24)"><rect fill="#DAE2ED" fill-rule="nonzero" x="10.579" y="11.24" width="80.667" height="5.951" rx="2.975"></rect><rect fill="#DAE2ED" fill-rule="nonzero" width="50.913" height="5.951" rx="2.975"></rect><path d="M13.555 21.82H88.27a2.975 2.975 0 010 5.95H13.555a2.975 2.975 0 010-5.95z" fill="#DAE2ED" fill-rule="nonzero"></path><g transform="translate(0 10.58)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.612" height="6.612" rx="2"></rect><path d="M2.812 4.96a.337.337 0 01-.245-.107L1.34 3.564a.378.378 0 010-.515.334.334 0 01.49 0l.98 1.031 2.206-2.32a.334.334 0 01.49 0 .378.378 0 010 .515l-2.45 2.578a.337.337 0 01-.245.107" fill="#FFF"></path></g><rect fill="#DAE2ED" fill-rule="nonzero" y="21.158" width="6.612" height="6.612" rx="2"></rect></g><rect fill="#FFF" fill-rule="nonzero" width="121" height="62.153" rx="4"></rect><path d="M0 49.59h121v9.224a4 4 0 01-4 4H4a4 4 0 01-4-4V49.59z" fill="#51DCA9" fill-rule="nonzero"></path><g transform="translate(9.257 11.24)"><path d="M14.877 11.24H98.85a2.975 2.975 0 010 5.951H14.877a2.975 2.975 0 110-5.95zM2.975 0h50.913a2.975 2.975 0 110 5.95H2.975a2.975 2.975 0 110-5.95zM14.877 21.82H98.85a2.975 2.975 0 010 5.95H14.877a2.975 2.975 0 110-5.95z" fill="#DAE2ED" fill-rule="nonzero"></path><g transform="translate(0 10.58)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.612" height="6.612" rx="2"></rect><path d="M2.812 4.96a.337.337 0 01-.245-.107L1.34 3.564a.378.378 0 010-.515.334.334 0 01.49 0l.98 1.031 2.206-2.32a.334.334 0 01.49 0 .378.378 0 010 .515l-2.45 2.578a.337.337 0 01-.245.107" fill="#FFF"></path></g><rect fill="#DAE2ED" fill-rule="nonzero" y="21.158" width="6.612" height="6.612" rx="2"></rect></g><path stroke="#319BF3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M8.596 86.646h104.47"></path><circle stroke="#319BF3" stroke-width="1.5" fill="#51DCA9" fill-rule="nonzero" cx="60.831" cy="86.646" r="3.967"></circle><circle fill="#319BF3" fill-rule="nonzero" cx="9.918" cy="86.646" r="3.967"></circle><circle fill="#319BF3" fill-rule="nonzero" cx="111.743" cy="86.646" r="3.967"></circle></g></svg>
  )
}


const DesktopClassicForm = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121 125" class="jfWizard-list-item-icon-svg" width='187px' height='182px'><g fill="none" fill-rule="evenodd"><path d="M4.417 0h112a4 4 0 014 4v121h-120V4a4 4 0 014-4z" fill="#FFF" fill-rule="nonzero"></path><g transform="translate(10.417 13)"><path d="M17.001 31.122h79.14a2.858 2.858 0 010 5.716h-79.14a2.858 2.858 0 110-5.716z" fill="#DAE2ED" fill-rule="nonzero"></path><rect fill="#DAE2ED" fill-rule="nonzero" y="20.324" width="74.571" height="5.716" rx="2.858"></rect><rect fill="#DAE2ED" fill-rule="nonzero" width="99" height="8.257" rx="3"></rect><path d="M17.001 41.284h79.14a2.858 2.858 0 010 5.716h-79.14a2.858 2.858 0 110-5.716z" fill="#DAE2ED" fill-rule="nonzero"></path><g transform="translate(0 30.486)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.429" height="6.351" rx="2"></rect><path d="M2.734 4.765a.33.33 0 01-.238-.103L1.304 3.424a.36.36 0 010-.495.328.328 0 01.477 0l.953.99L4.878 1.69a.328.328 0 01.477 0 .36.36 0 010 .496L2.972 4.662a.33.33 0 01-.238.103" fill="#FFF"></path></g><rect fill="#DAE2ED" fill-rule="nonzero" y="40.649" width="6.429" height="6.351" rx="2"></rect></g><g transform="translate(10.417 72)"><path d="M17.036 10.929h79.071a2.893 2.893 0 010 5.785H17.036a2.893 2.893 0 110-5.785zM2.893 0h68.786a2.893 2.893 0 110 5.786H2.893a2.893 2.893 0 010-5.786zM17.036 21.214h79.071a2.893 2.893 0 010 5.786H17.036a2.893 2.893 0 110-5.786z" fill="#DAE2ED" fill-rule="nonzero"></path><g transform="translate(0 10.286)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.429" height="6.429" rx="2"></rect><path d="M2.734 4.823a.327.327 0 01-.238-.104L1.304 3.465a.367.367 0 010-.5.325.325 0 01.477 0l.953 1.002L4.878 1.71a.325.325 0 01.477 0 .367.367 0 010 .501L2.972 4.72a.328.328 0 01-.238.104" fill="#FFF"></path></g><rect fill="#DAE2ED" fill-rule="nonzero" y="20.571" width="6.429" height="6.429" rx="2"></rect><g transform="translate(0 20.571)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.429" height="6.429" rx="2"></rect><path d="M2.734 4.823a.327.327 0 01-.238-.104L1.304 3.465a.367.367 0 010-.5.325.325 0 01.477 0l.953 1.002L4.878 1.71a.325.325 0 01.477 0 .367.367 0 010 .501L2.972 4.72a.328.328 0 01-.238.104" fill="#FFF"></path></g></g><rect fill="#2F90FF" fill-rule="nonzero" x="77.417" y="109" width="32" height="10" rx="4"></rect></g></svg>
  )
}


const DesktopCardForm = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121 92" class="jfWizard-list-item-icon-svg" width='166px' height='146px'><g fill="none" fill-rule="evenodd"><rect fill="#FFF" fill-rule="nonzero" x="7.934" width="105.131" height="62.153" rx="4"></rect><path d="M7.934 49.59h105.132v9.224a4 4 0 01-4 4H11.934a4 4 0 01-4-4V49.59z" fill="#2A5ACA" fill-rule="nonzero"></path><g transform="translate(15.208 11.24)"><rect fill="#DAE2ED" fill-rule="nonzero" x="10.579" y="11.24" width="80.667" height="5.951" rx="2.975"></rect><rect fill="#DAE2ED" fill-rule="nonzero" width="50.913" height="5.951" rx="2.975"></rect><path d="M13.555 21.82H88.27a2.975 2.975 0 010 5.95H13.555a2.975 2.975 0 010-5.95z" fill="#DAE2ED" fill-rule="nonzero"></path><g transform="translate(0 10.58)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.612" height="6.612" rx="2"></rect><path d="M2.812 4.96a.337.337 0 01-.245-.107L1.34 3.564a.378.378 0 010-.515.334.334 0 01.49 0l.98 1.031 2.206-2.32a.334.334 0 01.49 0 .378.378 0 010 .515l-2.45 2.578a.337.337 0 01-.245.107" fill="#FFF"></path></g><rect fill="#DAE2ED" fill-rule="nonzero" y="21.158" width="6.612" height="6.612" rx="2"></rect></g><rect fill="#FFF" fill-rule="nonzero" width="121" height="62.153" rx="4"></rect><path d="M0 49.59h121v9.224a4 4 0 01-4 4H4a4 4 0 01-4-4V49.59z" fill="#51DCA9" fill-rule="nonzero"></path><g transform="translate(9.257 11.24)"><path d="M14.877 11.24H98.85a2.975 2.975 0 010 5.951H14.877a2.975 2.975 0 110-5.95zM2.975 0h50.913a2.975 2.975 0 110 5.95H2.975a2.975 2.975 0 110-5.95zM14.877 21.82H98.85a2.975 2.975 0 010 5.95H14.877a2.975 2.975 0 110-5.95z" fill="#DAE2ED" fill-rule="nonzero"></path><g transform="translate(0 10.58)"><rect fill="#2F90FF" fill-rule="nonzero" width="6.612" height="6.612" rx="2"></rect><path d="M2.812 4.96a.337.337 0 01-.245-.107L1.34 3.564a.378.378 0 010-.515.334.334 0 01.49 0l.98 1.031 2.206-2.32a.334.334 0 01.49 0 .378.378 0 010 .515l-2.45 2.578a.337.337 0 01-.245.107" fill="#FFF"></path></g><rect fill="#DAE2ED" fill-rule="nonzero" y="21.158" width="6.612" height="6.612" rx="2"></rect></g><path stroke="#319BF3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M8.596 86.646h104.47"></path><circle stroke="#319BF3" stroke-width="1.5" fill="#51DCA9" fill-rule="nonzero" cx="60.831" cy="86.646" r="3.967"></circle><circle fill="#319BF3" fill-rule="nonzero" cx="9.918" cy="86.646" r="3.967"></circle><circle fill="#319BF3" fill-rule="nonzero" cx="111.743" cy="86.646" r="3.967"></circle></g></svg>
  )
}



const ImportFormIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 142 168" class="jfWizard-list-item-icon-svg" width="142" height="168"><g fill-rule="nonzero" fill="none"><g><rect fill="#E2E7EF" width="120" height="146.301" rx="4"></rect><rect fill="#C3CEE7" x="8" y="8" width="103.562" height="34.521" rx="4"></rect><path d="M11.041 51.315h45.78a3 3 0 013 3v3.041a3 3 0 01-3 3h-45.78a3 3 0 01-3-3v-3.04a3 3 0 013-3z" fill-opacity="0.874" fill="#B9C2CF"></path><rect fill-opacity="0.874" fill="#B9C2CF" x="8.041" y="87.479" width="51.781" height="9.041" rx="3"></rect><rect fill-opacity="0.713" fill="#99A3B1" x="8" y="67" width="103.562" height="9.041" rx="3"></rect><rect fill-opacity="0.713" fill="#99A3B1" x="8" y="103" width="103.562" height="9.041" rx="3"></rect></g><g transform="translate(22 21)"><rect fill="#FFF" width="120" height="146.301" rx="4"></rect><rect fill="#94ACE3" x="8" y="8" width="103.562" height="34.521" rx="4"></rect><path d="M11.041 51.315h45.78a3 3 0 013 3v3.041a3 3 0 01-3 3h-45.78a3 3 0 01-3-3v-3.04a3 3 0 013-3z" fill="#C6CDD9"></path><rect fill="#C6CDD9" x="8.041" y="87.479" width="51.781" height="9.041" rx="3"></rect><rect fill="#A7B1C0" x="8" y="67" width="103.562" height="9.041" rx="3"></rect><rect fill="#A7B1C0" x="8" y="103" width="103.562" height="9.041" rx="3"></rect></g></g></svg>
  )
}



const AllFormMessageIcon = () => {
  return (


<svg xmlns="http://www.w3.org/2000/svg" width="198" height="140" fill="none" class="lsApp-noForms-icon-standalone"><path fill="#E6E6F5" d="M0 97.061c0-23.632 19.158-42.79 42.79-42.79h112.325c23.632 0 42.79 19.158 42.79 42.79s-19.158 42.79-42.79 42.79H42.79C19.158 139.851 0 120.693 0 97.061"></path><mask id="noAssignedForms_svg__a" width="198" height="86" x="0" y="54" maskUnits="userSpaceOnUse"  ><path fill="#E6E6F5" d="M0 97.061c0-23.632 19.158-42.79 42.79-42.79h112.325c23.632 0 42.79 19.158 42.79 42.79s-19.158 42.79-42.79 42.79H42.79C19.158 139.851 0 120.693 0 97.061"></path></mask><g mask="url(#noAssignedForms_svg__a)"><path fill="#CD7448" fill-rule="evenodd" d="M115.336 77.547q-12.651 15.957-20.705 20.579c-8.054 4.622-8.643-.235-38.14-20.745-2.052-.861-3.715-1.09-6.495 2q-2.493 2.773-10.721 1.46a1.014 1.014 0 0 0-1.16.836c-.045.273.025.552.193.772q2.025 2.655 7.009 2.893c6.592.317 7.3-2.156 11.01.758s23.584 26.213 35.57 26.792c11.985.579 27.733-17.227 32.188-18.6q4.455-1.371 7.268-21.678z" clip-rule="evenodd"></path><path fill="#F4F5FE" fill-rule="evenodd" d="M58.955 89.68q4.905-4.683 5.949-8.17Q86.846 97.902 89.74 97.005c2.647-.82 24.004-20.019 31.425-24.56.673-.673.721 5.077 1.257 4.458l-2.407 22.314q-13 9.303-16.566 11.463c-3.565 2.16-12.921 6.115-21.371-.755q-8.45-6.87-23.124-20.246Z" clip-rule="evenodd"></path><path fill="#fff" d="M110.638 114.173c1.348 4.698 1.348 10.59 0 21.327l49.541-7.235-3.033-40.263q-3.033-10.065-7.077-14.092c-4.044-4.026-25.276-2.013-30.332 0-5.055 2.013-6.066 11.072-11.121 19.125s0 14.092 2.022 21.138"></path><path fill="#CD7448" fill-rule="evenodd" d="M141.981 71.779q-3.034 24.705-17.047 24.705c-14.014 0-10.728-7.372-8.973-10.829q1.754-3.456 3.859-12.305 7.232-2.308 11.039-2.578t11.122 1.007" clip-rule="evenodd"></path><mask id="noAssignedForms_svg__b" width="110" height="93" x="51" y="-1" maskUnits="userSpaceOnUse"  ><path fill="#C4C4C4" d="M51.289-1H160.64v92.712H51.289z"></path></mask><g mask="url(#noAssignedForms_svg__b)"><mask id="noAssignedForms_svg__c" width="59" height="92" x="106" y="71" maskUnits="userSpaceOnUse"  ><path fill="#fff" d="M110.638 138.166c1.348-10.737 1.348-19.295 0-23.992-2.023-7.046-7.078-13.086-2.023-21.139 5.056-8.052 6.067-17.111 11.122-19.125s26.287-4.026 30.331 0q4.045 4.027 7.078 14.093l3.033 40.263q7.077 27.177 2.022 33.217c-5.055 6.039-7.077-10.066-29.32-19.125-4.719-2.013-12.133-2.85-22.243-4.192"></path></mask><g mask="url(#noAssignedForms_svg__c)"><path fill="#fff" d="M110.638 138.164q2.022-16.106 0-23.151c-2.022-7.047-7.078-13.086-2.022-21.139 5.055-8.052 5.782-17.822 10.837-19.835 5.056-2.014 25.832-4.915 29.877-.889 2.696 2.685 5.794 8.98 7.816 15.691v13.61l3.033 26.654q7.077 27.177 2.022 33.217c-5.055 6.039-7.077-10.066-29.32-19.125q-7.077-3.02-22.243-5.033"></path><path fill="#CD7448" fill-rule="evenodd" d="M141.98 71.78q-3.033 24.704-17.047 24.704c-14.013 0-10.728-7.372-8.973-10.829q1.755-3.456 3.859-12.305 7.232-2.307 11.04-2.578t11.121 1.007Z" clip-rule="evenodd"></path></g><path fill="#0A1551" fill-rule="evenodd" d="M113.82 32.942c-3.39 14.435-4.541 16.131-5.802 19.302a2.15 2.15 0 0 0 .438 2.294q7.2 7.431 19.261 4.643c8.566-1.98 8.525-4.956 3.217-29.137z" clip-rule="evenodd"></path><path fill="#CD7448" d="M136.285 53.625c-1.661 12.973 3.905 17.523 5.814 17.556 1.91.032-5.401 8.023-19.033 20.809-4.46-8.598-4.959-16.266-3.566-18.49 2.09-3.336 4.029-.482 3.313-12.161-.471-7.672 9.73-6.943 16.997-8.188-3.525.474-9.282.592-3.525.474"></path><path fill="#BD5826" fill-rule="evenodd" d="M122.313 56.15c.792 7.228.769 11.214.687 11.85-.122.954 17.282.148 12.312-15.173s-6.632 1.805-12.999 3.324Z" clip-rule="evenodd" opacity="0.677"></path><mask id="noAssignedForms_svg__d" width="38" height="44" x="113" y="23" maskUnits="userSpaceOnUse"  ><path fill="#fff" d="M145.093 56.673q-6.864 9.171-19.143 10.065c-8.314.606-13.863-10.234-12.793-21.363.51-5.31 1.686-9.997 6.362-14.827q14.476-14.952 27.2 3.95l3.662 9.771z"></path></mask><g mask="url(#noAssignedForms_svg__d)"><path fill="#CD7448" d="M143.967 55.8q-7.663 8.516-19.978 8.304c-8.336-.144-12.886-11.436-10.817-22.421.988-5.242 2.582-9.803 7.676-14.193q15.77-13.59 26.74 6.375l2.767 10.059-6.388 11.877Z"></path><path fill="#A44616" d="M131.771 56.015c-2.695-.416-4.642-2.252-4.348-4.1s2.718-3.007 5.414-2.59c2.695.416 4.641 2.251 4.347 4.099-.294 1.847-2.717 3.008-5.413 2.591" opacity="0.423"></path></g><path fill="#A5330A" fill-rule="evenodd" d="M125.579 55.603q-3.178 1.358-7.501-1.401 2.035 5.777 4.624 5.258t2.877-3.857" clip-rule="evenodd"></path><path fill="#0A1551" fill-rule="evenodd" d="M126.938 38.088c-7.822-1.299-11.005-1.904-13.711-4.047.156-10.06 8.434-15.98 12.27-16.877 8.871-2.163 18.502.543 24.413 8.327a15 15 0 0 1 1.478 2.365q.349.56.689 1.256c3.699 10.658 5.645 26.207 4.589 31.967-2.957 3.801-26.688 4.62-23.716-.143.165-.266.351-.542.547-.835 1.396-2.08 3.388-5.046 3.369-11.71-.004-1.614-.471-3.501-.996-5.63-.178-.72-.363-1.467-.539-2.24l-1.197-.417c-1.691-.588-2.986-1.038-3.79-1.386-.879-.381-.04-2.924.562-4.75.527-1.594.872-2.64-.265-1.223-1.466 1.825-2.026 3.253-2.301 4.373-.156.637-.755 1.077-1.402.97" clip-rule="evenodd"></path><path fill="#fff" d="M115.165 138.36c5.329-2.997 29.268 3.736 47.509-2.946 10-3.663 2.348-24.998-1.822-42.89-2.639-9.901-7.007-16.464-10.989-18.891l-8.662 6.374 2.206 11.872s-1.371 4.311 1.516 12.143 7.375 17.68 7.375 17.68l-42.924 9.005c.154 3.55 1.528 10.051 5.791 7.653"></path></g><path fill="#CD7448" fill-rule="evenodd" d="M120.877 136.904c-2.093 1.665-3.098 1.719-5.599 3.64-2.013.964-3.499 1.379-7.866.075q-3.929-1.174-11.104-.601a1.008 1.008 0 0 1-.948-1.516q1.823-3.066 7.103-3.59c6.58-.653 7.399 1.778 10.978-1.318q3.58-3.097 7.436 3.31" clip-rule="evenodd"></path><path fill="url(#noAssignedForms_svg__e)" d="M116.883 140.37c10.617-.87 29.269 3.736 47.509-2.946 10.001-3.663 2.348-24.998-1.822-42.889-2.638-9.902-7.006-16.465-10.989-18.892l-8.661 6.374 2.205 11.873s-1.371 4.31 1.517 12.142 7.374 17.68 7.374 17.68l-42.924 9.005c.154 3.55-1.092 7.283 5.791 7.653"></path></g><mask id="noAssignedForms_svg__f" width="64" height="78" x="96" y="14" maskUnits="userSpaceOnUse"  ><path fill="#C4C4C4" d="M96 14h64v78H96z"></path></mask><g mask="url(#noAssignedForms_svg__f)"><mask id="noAssignedForms_svg__g" width="59" height="92" x="106" y="71" maskUnits="userSpaceOnUse"  ><path fill="#fff" d="M110.349 138.166c1.348-10.737 1.348-19.295 0-23.992-2.022-7.046-7.077-13.086-2.022-21.139s6.066-17.111 11.121-19.125 26.288-4.026 30.332 0q4.044 4.027 7.077 14.093l3.033 40.263q7.078 27.177 2.022 33.217c-5.055 6.039-7.077-10.066-29.32-19.125-4.718-2.013-12.133-2.85-22.243-4.192"></path></mask><g mask="url(#noAssignedForms_svg__g)"><path fill="#fff" d="M110.349 138.164q2.022-16.106 0-23.151c-2.022-7.047-7.077-13.086-2.022-21.139s5.782-17.822 10.838-19.835 25.832-4.915 29.876-.889c2.696 2.685 5.794 8.98 7.816 15.691v13.61l3.033 26.654q7.078 27.177 2.023 33.217c-5.056 6.039-7.078-10.066-29.321-19.125q-7.077-3.02-22.243-5.033"></path><path fill="#CD7448" fill-rule="evenodd" d="M141.692 71.78q-3.034 24.704-17.047 24.704c-14.014 0-10.728-7.372-8.973-10.829q1.755-3.456 3.859-12.305 7.232-2.307 11.039-2.578 3.808-.27 11.122 1.007Z" clip-rule="evenodd"></path></g><path fill="#0A1551" fill-rule="evenodd" d="M113.531 32.942c-3.39 14.435-4.541 16.131-5.802 19.302a2.15 2.15 0 0 0 .439 2.294q7.199 7.431 19.261 4.643c8.565-1.98 8.525-4.956 3.216-29.137z" clip-rule="evenodd"></path><path fill="#CD7448" d="M135.996 53.625c-1.66 12.973 3.906 17.523 5.815 17.556 1.909.032-5.402 8.023-19.033 20.809-4.461-8.598-4.96-16.266-3.567-18.49 2.09-3.336 4.03-.482 3.313-12.161-.47-7.672 9.731-6.943 16.998-8.188-3.526.474-9.282.592-3.526.474"></path><path fill="#BD5826" fill-rule="evenodd" d="M122.024 56.15c.792 7.228.769 11.214.688 11.85-.123.954 17.281.148 12.311-15.173s-6.632 1.805-12.999 3.324Z" clip-rule="evenodd" opacity="0.677"></path><mask id="noAssignedForms_svg__h" width="39" height="44" x="112" y="23" maskUnits="userSpaceOnUse"  ><path fill="#fff" d="M144.804 56.673q-6.862 9.171-19.143 10.065c-8.313.606-13.863-10.234-12.793-21.363.511-5.31 1.687-9.997 6.363-14.827q14.475-14.952 27.2 3.95l3.662 9.771z"></path></mask><g mask="url(#noAssignedForms_svg__h)"><path fill="#CD7448" d="M143.679 55.8q-7.665 8.516-19.978 8.304c-8.337-.144-12.887-11.436-10.817-22.421.987-5.242 2.582-9.803 7.675-14.193q15.77-13.59 26.741 6.375l2.766 10.059-6.387 11.877Z"></path><path fill="#37120C" fill-opacity="0.25" fill-rule="evenodd" d="M128.905 40.455c1.203.588 2.055 1.53 2.483 2.24a.594.594 0 1 1-1.017.613c-.328-.544-1.019-1.313-1.987-1.785-.944-.462-2.165-.649-3.626-.043a.595.595 0 0 1-.456-1.099c1.803-.746 3.379-.524 4.603.074m-11.461-1.975a3.34 3.34 0 0 0-2.266.716.594.594 0 1 0 .746.926c.318-.256.83-.49 1.456-.455.614.034 1.414.331 2.312 1.269a.594.594 0 1 0 .858-.822c-1.063-1.11-2.133-1.58-3.106-1.634" clip-rule="evenodd"></path><path fill="#A44616" d="M131.483 56.015c-2.696-.416-4.642-2.252-4.348-4.1s2.718-3.007 5.413-2.59c2.695.416 4.642 2.251 4.348 4.099-.295 1.847-2.718 3.008-5.413 2.591m-21.519-4.46c-2.647-.672-4.479-2.7-4.092-4.529s2.849-2.766 5.496-2.093c2.648.672 4.48 2.7 4.092 4.529-.387 1.829-2.848 2.766-5.496 2.093" opacity="0.423"></path></g><path fill="#A5330A" fill-rule="evenodd" d="M125.29 55.603q-3.178 1.358-7.5-1.401 2.034 5.777 4.623 5.258t2.877-3.857" clip-rule="evenodd"></path><path fill="#321907" d="M126.3 46.2c-.558-.01-1-.68-.987-1.498.012-.818.475-1.474 1.033-1.465.558.01 1 .68.987 1.5-.013.817-.475 1.473-1.033 1.463m-8.6-1.551c-.558-.01-1-.68-.987-1.499.013-.818.476-1.474 1.034-1.464s1 .68.987 1.499c-.013.818-.476 1.473-1.034 1.464"></path><path fill="#8A3110" fill-rule="evenodd" d="M122.715 43.596a.36.36 0 0 0-.5.07c-.982 1.305-1.621 1.94-2.222 2.378a9 9 0 0 1-.943.587l-.291.16c-.266.146-.562.307-.891.5-1.157.682-1.326 2.25-.801 3.413.27.6.736 1.135 1.393 1.442.661.309 1.483.372 2.434.084a.355.355 0 0 0 .237-.444.36.36 0 0 0-.446-.237c-.809.245-1.445.175-1.923-.047a2.16 2.16 0 0 1-1.044-1.088c-.437-.97-.215-2.08.514-2.51.319-.187.599-.34.863-.484l.304-.167c.351-.194.68-.388 1.018-.635.68-.496 1.367-1.192 2.37-2.524a.356.356 0 0 0-.072-.498" clip-rule="evenodd"></path><path fill="#0A1551" fill-rule="evenodd" d="M126.649 38.088c-7.821-1.299-11.005-1.904-13.71-4.047.156-10.06 8.433-15.98 12.269-16.877 8.871-2.163 18.502.543 24.413 8.327a15 15 0 0 1 1.479 2.365q.348.56.689 1.256c3.698 10.658 5.644 26.207 4.589 31.967-2.957 3.801-26.689 4.62-23.717-.143q.25-.397.548-.835c1.396-2.08 3.387-5.046 3.368-11.71-.004-1.614-.47-3.501-.996-5.63-.178-.72-.362-1.467-.538-2.24l-1.197-.417c-1.691-.588-2.986-1.038-3.79-1.386-.88-.381-.041-2.924.562-4.75.526-1.594.872-2.64-.266-1.223-1.465 1.825-2.025 3.253-2.3 4.373-.157.637-.755 1.077-1.403.97" clip-rule="evenodd"></path><path fill="#fff" d="M114.876 138.36c5.329-2.997 29.269 3.736 47.509-2.946 10-3.663 2.348-24.998-1.822-42.89-2.638-9.901-7.006-16.464-10.989-18.891l-8.662 6.374 2.206 11.872s-1.371 4.311 1.517 12.143 7.374 17.68 7.374 17.68l-42.924 9.005c.154 3.55 1.528 10.051 5.791 7.653"></path></g><path fill="#fff" d="M38 4.583A4.583 4.583 0 0 1 42.583 0h21.77a4.583 4.583 0 0 1 4.582 4.583v27.498a4.583 4.583 0 0 1-4.583 4.583H42.583A4.583 4.583 0 0 1 38 32.081z"></path><path fill="#C8CEED" fill-rule="evenodd" d="M64.352 1.146H42.583a3.437 3.437 0 0 0-3.437 3.437v27.498a3.437 3.437 0 0 0 3.437 3.437h21.77a3.437 3.437 0 0 0 3.437-3.437V4.583a3.437 3.437 0 0 0-3.438-3.437M42.583 0A4.583 4.583 0 0 0 38 4.583v27.498a4.583 4.583 0 0 0 4.583 4.583h21.77a4.583 4.583 0 0 0 4.582-4.583V4.583A4.583 4.583 0 0 0 64.352 0z" clip-rule="evenodd"></path><path fill="#09F" d="M44.547 12.44c0-1.085.88-1.964 1.964-1.964h14.404a1.964 1.964 0 1 1 0 3.928H46.51a1.964 1.964 0 0 1-1.964-1.964Z"></path><path fill="#FF6100" d="M44.547 18.987c0-1.085.88-1.964 1.964-1.964h14.404a1.964 1.964 0 1 1 0 3.928H46.51a1.964 1.964 0 0 1-1.964-1.964Z"></path><path fill="#FFB629" d="M44.547 25.534c0-1.085.88-1.964 1.964-1.964h14.404a1.964 1.964 0 0 1 0 3.928H46.51a1.964 1.964 0 0 1-1.964-1.964Z"></path><path fill="#fff" d="M57.065 44.583A4.583 4.583 0 0 1 61.648 40h21.769A4.583 4.583 0 0 1 88 44.583v27.498a4.583 4.583 0 0 1-4.583 4.583h-21.77a4.583 4.583 0 0 1-4.582-4.583z"></path><path fill="#C8CEED" fill-rule="evenodd" d="M83.417 41.146h-21.77a3.437 3.437 0 0 0-3.437 3.437v27.498a3.437 3.437 0 0 0 3.438 3.437h21.769a3.437 3.437 0 0 0 3.437-3.437V44.583a3.437 3.437 0 0 0-3.437-3.437M61.647 40a4.583 4.583 0 0 0-4.582 4.583v27.498a4.583 4.583 0 0 0 4.583 4.583h21.769A4.583 4.583 0 0 0 88 72.081V44.583A4.583 4.583 0 0 0 83.417 40z" clip-rule="evenodd"></path><path fill="#09F" d="M63.611 52.44c0-1.085.88-1.964 1.965-1.964h14.403a1.964 1.964 0 0 1 0 3.928H65.576a1.964 1.964 0 0 1-1.965-1.964"></path><path fill="#FF6100" d="M63.611 58.987c0-1.085.88-1.965 1.965-1.965h14.403a1.964 1.964 0 1 1 0 3.929H65.576a1.964 1.964 0 0 1-1.965-1.964"></path><path fill="#FFB629" d="M63.611 65.534c0-1.085.88-1.964 1.965-1.964h14.403a1.964 1.964 0 0 1 0 3.928H65.576a1.964 1.964 0 0 1-1.965-1.964"></path><path fill="#fff" d="M18 44.583A4.583 4.583 0 0 1 22.583 40h21.77a4.583 4.583 0 0 1 4.582 4.583v27.498a4.583 4.583 0 0 1-4.583 4.583H22.583A4.583 4.583 0 0 1 18 72.081z"></path><path fill="#C8CEED" fill-rule="evenodd" d="M44.352 41.146H22.583a3.437 3.437 0 0 0-3.437 3.437v27.498a3.437 3.437 0 0 0 3.437 3.437h21.77a3.437 3.437 0 0 0 3.437-3.437V44.583a3.437 3.437 0 0 0-3.438-3.437M22.583 40A4.583 4.583 0 0 0 18 44.583v27.498a4.583 4.583 0 0 0 4.583 4.583h21.77a4.583 4.583 0 0 0 4.582-4.583V44.583A4.583 4.583 0 0 0 44.352 40z" clip-rule="evenodd"></path><path fill="#09F" d="M24.547 52.44c0-1.085.88-1.964 1.964-1.964h14.404a1.964 1.964 0 0 1 0 3.928H26.51a1.964 1.964 0 0 1-1.964-1.964Z"></path><path fill="#FF6100" d="M24.547 58.987c0-1.085.88-1.965 1.964-1.965h14.404a1.964 1.964 0 1 1 0 3.929H26.51a1.964 1.964 0 0 1-1.964-1.964Z"></path><path fill="#FFB629" d="M24.547 65.534c0-1.085.88-1.964 1.964-1.964h14.404a1.964 1.964 0 0 1 0 3.928H26.51a1.964 1.964 0 0 1-1.964-1.964Z"></path><defs><linearGradient id="noAssignedForms_svg__e" x1="152.19" x2="149.764" y1="93.503" y2="110.514" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"></stop><stop offset="1" stop-color="#F3F5FE"></stop></linearGradient></defs></svg>  
  
  )
}







export {
  Heading,
  FullName,
  Email,
  Address,
  Phone,
  Appointment,
  DatePicker,
  ProductList,
  FillInTheBlank,
  Signature,
  ShortText,
  LongText,
  Paragraph,
  DropDown,
  SingleChoice,
  MultiChoice,
  Number,
  Image,
  FileUpload,
  Time,
  Captcha,
  Spinner,
  Submit,
  Table,
  StarRating,
  ScaleRating,
  Divider,
  Page,
  Section,
  List,
  TableParagraph,
  ABCList,
  UploadFileIcon,
  ShortTextBlue,
  DropDownFill,
  SettingIcon,
  EmailSetting,
  Conditions,
  Mobile,
  Sign,
  Thanks,
  Puzzle,
  Approval,
  Message,
  EmailSettingPage,
  EmailNotofication,
  AutoEmail,
  DigestEmail,
  ConditionPage,
  PreviewCondition,
  PreviewCalculate,
  PreviewEnable,
  PreviewSkip,
  PreviewConfirm,
  PreviewMessage,
  ArrowCondition,
  GeneralSetting,
  EnableFormSetting,
  SettingFormStatus,
  SettingApproval,
  SettingThankYouPage,
  LinkSetting,
  UploadSetting,
  Warning,
  EmailLink,
  Hide,
  Show,
  Calculate,
  Require,
  ConditionArrow,
  ConditionSetting,
  CloseSetting,
  DeleteConditionSetting,
  DisableConditionSetting,
  EnableConditionSetting,
  Division,
  TickSetting,
  EmailListSetting,
  ArrowEmailSetting,
  Function,
  MainPageDrawer,
  TemplateIcon,
  ImportCreateForm,
  AddCreateForm,
  ClassicForm,
  CardForm,
  DesktopClassicForm,
  DesktopCardForm,
  ImportFormIcon,
  AllFormMessageIcon
};
